import React, { useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import AutoComplete from 'src/common/refactoredComponents/form/autocomplete/AutoComplete.jsx';
import {
    HeadingShipAddress,
    MainContainer,
    Title,
    RadioRowDiv,
    DistrictContainer,
    ShippingContainerSize,
    ShippingContainer,
    SelectShipToAddressContainer,
    AdvanceSelectButton,
    AutoCompleteContainer,
    AlertMsg,
    ShipToCorousalDiv,
    SelectTemplate,
    HeaderDiv,
    HeaderTitle,
    Icon,
    CarousalContainer,
    DetailsMainContainer,
    MainContainerSecond,
    MainContainerThird,
    OptionContainer,
    ImageContainer,
    SurgeryDateViewAndNumberContainer,
    FlexDiv,
} from './ShipAddressModal.styled';
import { OptionalLoadMoreView } from 'src/common/components/createTemplate/CreateTemplate.styled.jsx';
import {
    getDropdownOptionsRequest,
    getShipToAddress,
    getShippingMethods,
    clearInsideShippingAddress,
    setUsageSurgeryInsideAction,
    clearOutsideShippingAddress,
    setSelectedOutsideAccount,
    resetRepleneShippingMethods,
    setShippingDetails,
    storeRequestDeliveryDate,
    getTransferRecipientMethods,
    clearTransferRecipients,
    clearInsideShippingAddressWhenBillToCleared,
    setReplenishmentSurgeryNumber,
    clearValidateReplenData,
    setTerritoryValue,
    clearSingleDropDownList,
    storeSurgeryDete,
} from 'src/pages/reportUsage/redux/action/actionCreators';
import AdvanceAccountSearch from './AdvanceAccountSearch';
import ReportAutoComplete from 'src/pages/reportUsage/common/autoComplete/ReportAutoComplete';
import InputField from 'src/pages/reportUsage/common/inputField/InputField';
import CollapsableCard from 'src/common/refactoredComponents/collapsableCard/CollapsableCard.jsx';
import RadioButton from 'src/common/refactoredComponents/RadioButton/RadioButton';
import Select from 'src/common/refactoredComponents/select/Select';
import { sizes } from 'src/styles/Media.styled';
import InputBox from 'src/common/refactoredComponents/input/Input';
import Carousel from 'src/common/refactoredComponents/carousel/index';
import Button from 'src/common/refactoredComponents/button/Button';
import { ButtonStyles } from 'src/constants/buttonStyles';
import SelectShipToAddressOutside from './SelectShipToAddressOutside';
import AccountPhysicianTemplate from 'src/pages/scheduleSurgery/components/details/AccountPhysicianTemplate';
import ShippingAddressCard from 'src/pages/scheduleSurgery/components/shipping/ShippingAddressCard';
import Calendar from 'src/assets/images/CalendarTodayBlue.svg';
import DatePicker from 'src/common/refactoredComponents/datePicker/DatePicker';
import BottomNavigation from 'src/common/refactoredComponents/bottomNavigation/BottomNavigation';
import {
    MainContainerItems,
    Subtitle,
    SurgeryDateViewAndNumber,
} from 'src/pages/scheduleSurgery/components/details/Details.styled.jsx';
import axios from 'src/api/Api';
import {
    accountNumberZeroTrimmer,
    convertDateToISOString,
    isIpad,
    isMobileView,
    getAccountDetails,
    debounce,
    logErrorToConsole,
} from 'src/utils/util';
import { CommonEmptyBox } from 'src/styles/CommonStyles.styled';
import ModalDialog from 'src/common/refactoredComponents/modalDialog/modalDialog';
import Close from 'src/assets/images/CloseProduct.svg';
import {
    WithinTerritory,
    OutsideTerritory,
    AllDistricts,
} from 'src/pages/reportUsage/replen/components/replenConstant';
import { RequestDeliveryDateView } from 'src/pages/consignmentAdd/components/account/AccountContainer.styled';
import {
    getDisabledDatesBasedOnJapanTime,
    getJapanCurrentDateTime,
    getMinimumDatesBasedOnJapanTime,
    getTomorrowDate,
    getRddDate,
    getNumberOfDaysBetweenTwoDates,
} from 'src/utils/dateUtils';
import moment from 'moment';
import { COUNTRY_CODE_JAPN } from 'src/constants/productConstants';
import {
    getRequestDeliveryDateForReplenish,
    getCareOfFieldForReplenish,
    getSurgeryDateForReplenish,
    getTransferRecipientForReplenish,
    getSurgeryNumberForReplenish,
    getShipToAddressForReplenish,
    getShippingMethodReplenish,
} from 'src/pages/reportUsage/utils/dataModificaionUtil';
import {
    VISIBLE,
    US_COUNTRY_CODE,
    MANDATORY,
    CC_USER_ROLE,
    CSR_USER_ROLE,
} from 'src/constants/appConstants';
import { DropdownOption } from 'src/constants/templateConstants';
import ShipToTemplate from 'src/pages/reportUsage/procedure/components/shipToTemplate/shipToTemplate';
import { SurgeryDateView } from '../../../../scheduleSurgery/components/details/Details.styled';
import { getHolidayList } from 'src/pages/scheduleSurgery/redux/actions';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';

const ShipAddressModal = ({
    onClose,
    gridData,
    setGridData,
    territoriesFromIndex,
    applyShippingAddress = () => {},
    ApplyShipToAddress = () => {},
    setSelectedBillToId = () => {},
    selectedBillToId,
    setUsageTransferRecipient = () => {},
    usageTransferRecipient,
    setShippingMethodValue = () => {},
    shippingMethodValue,
    setSelectedShipTo = () => {},
    selectedShipTo,
    setShipToClick = () => {},
    applyClickOutside,
    setApplyClickOutside = () => {},
    shipToClick,
    setCareOfValue = () => {},
    careOfValue,
    setInsideAccountDetails = () => {},
    insideAccountDetails,
    setAttnValue,
    attnValue,
}) => {
    const dispatch = useDispatch();
    const screenWidth = window.innerWidth;
    const { t } = useTranslation();
    const shipToRef = useRef();
    const accountRef=useRef(null);
    const shipToAddressOutsideRef = useRef();
    const transferRecipientRef = useRef();
    const billToRef = useRef();
    const [currentOrientation, setCurrentOrientation] = useState({
        width: window.innerWidth,
        height: window.innerHeight
    });

    const [initialLoad, setInitialLoad] = useState(true);
    const [shippingMethodInitial, setShippingMethodInitial] = useState(true);
    const isInitialMount = useRef(true);
    const selectedGridItems = gridData?.filter(item => item?.isSelected && !item?.accountOwned);
    const selectedItemsWithShipTo = selectedGridItems?.filter(item =>
        item?.shippingDetails?.shippingAddress?.shippingAddressId
    ) || [];
    const allSelectedHaveSameShipTo = selectedItemsWithShipTo.length > 0 &&
        selectedItemsWithShipTo.every(item =>
            item.shippingDetails.shippingAddress.shippingAddressId ===
            selectedItemsWithShipTo[0].shippingDetails.shippingAddress.shippingAddressId
        );
    const savedShipToFromGrid = allSelectedHaveSameShipTo
        ? selectedItemsWithShipTo[0].shippingDetails.shippingAddress
        : null;

    const selectedItemsWithShippingMethod = selectedGridItems?.filter(item =>
        item?.shippingDetails?.shippingMethod?.shippingMethodId
    ) || [];
    const allSelectedHaveSameShippingMethod = selectedItemsWithShippingMethod.length > 0 &&
        selectedItemsWithShippingMethod.every(item =>
            item.shippingDetails.shippingMethod.shippingMethodId ===
            selectedItemsWithShippingMethod[0].shippingDetails.shippingMethod.shippingMethodId
        );
    const savedShippingMethodFromGrid = allSelectedHaveSameShippingMethod
        ? selectedItemsWithShippingMethod[0].shippingDetails.shippingMethod
        : null;
    const initialSelectedShipToRef = useRef(
        selectedShipTo?.shippingAddressId ? selectedShipTo : savedShipToFromGrid || selectedShipTo
    );
    const hasRestoredShipToRef = useRef(false);
    const hasAutoPopulatedAccountRef = useRef(false);
    const initialShippingMethodRef = useRef(
        shippingMethodValue?.shippingMethodId ? shippingMethodValue : savedShippingMethodFromGrid || shippingMethodValue
    );
    const defaultShippingMethodRef = useRef(null);
    const {
        accounts,
        districts,
        territories,
        billToDetails,
        physicianDetails,
        surgeryDeliveryDateLeadTime,
        usageReplenishmentSurgeryDateVisibility,
        usageReplenishmentSurgeryDateMandatoryRule,
        enableRequestedDeliveryDateForWeekEnd,
        allDayRequestedDeliveryDate,
    } = useSelector((state) => ({
        accounts:
            state?.reportUsageRootReducer?.dropdownData?.accounts?.accounts,
        districts:
            state?.reportUsageRootReducer?.dropdownData?.districts?.districts,
        territories: state?.reportUsageRootReducer?.dropdownData?.territories
            ?.territories
            ? state?.reportUsageRootReducer?.dropdownData?.territories
                ?.territories
            : territoriesFromIndex,
        billToDetails:
            state?.reportUsageRootReducer?.dropdownData?.billToDetails
                ?.billToDetails,
        physicianDetails:
            state?.reportUsageRootReducer?.dropdownData?.physicians
                ?.physicianList,
        surgeryDeliveryDateLeadTime:
            state.loginReducer.surgeryDeliveryDateLeadTime,
        enableRequestedDeliveryDateForWeekEnd:
            state.loginReducer.enableRequestedDeliveryDateForWeekEnd,
        usageReplenishmentSurgeryDateVisibility:
            state.loginReducer.usageReplenishmentSurgeryDateVisibility,
        usageReplenishmentSurgeryDateMandatoryRule:
            state.loginReducer.usageReplenishmentSurgeryDateMandatoryRule,
        allDayRequestedDeliveryDate:
            state.loginReducer.allDayRequestedDeliveryDate,
    }));
    const isCondensedView = useSelector(
        (state) => state.loginReducer.isCondensedView
    );

    const selectedBillToIdFromSurgery = useSelector(
        (state) => state.orderSummaryReducer.orderBasicDetails
    );
    const winWidth = window.innerWidth;
    const [territory, setTerritory] = useState(WithinTerritory());
    const [hasManuallySelectedTerritory, setHasManuallySelectedTerritory] =
        useState(false);
    const closekeyBoard = () => {
        document.activeElement.blur();
    };
    let physicianRef = useRef();
    const {
        usageDetails,
        surgeryDetails,
        isInsideTerritory,
        accountId,
        reportUsageObject,
        replenishmentSurgeryNumber,
        surgeryNumberUsageReplenishmentVisibility,
        surgeryNumberUsageReplenishmentMandatory,
        physicianDropdownZGReportUsageReplenishmentVisibility,
        physicianDropdownZGReportUsageReplenishmentMandatory,
        selectedAccountId,
        requestedDeliveryDateCutOffTime,
        currentDateDelivery,
    } = useSelector((state) => ({
        usageDetails: state.reportUsageRootReducer.usageDetails,
        surgeryDetails: state.reportShipToAddressReducer.insideSurgeryDetails,
        selectedAccountId:
            state.reportShipToAddressReducer?.selectedAccount?.accountId
                ?.accountId,
        isInsideTerritory:
            state.surgeryvalidateAccountReducer.validateAccount?.data
                ?.isInsideTerrAcc,
        accountId: state.reportUsageRootReducer.usageDetails?.accountId,
        reportUsageObject: state.reportUsageRootReducer.reportUsageObject,
        replenishmentSurgeryNumber:
            state.reportUsageRootReducer.replenishmentSurgeryNumber,
        surgeryNumberUsageReplenishmentVisibility:
            state.loginReducer.surgeryNumberUsageReplenishmentVisibility,
        surgeryNumberUsageReplenishmentMandatory:
            state.loginReducer.surgeryNumberUsageReplenishmentMandatory,
        physicianDropdownZGReportUsageReplenishmentVisibility:
            state.loginReducer
                .physicianDropdownZGReportUsageReplenishmentVisibility,
        physicianDropdownZGReportUsageReplenishmentMandatory:
            state.loginReducer
                .physicianDropdownZGReportUsageReplenishmentMandatory,
        requestedDeliveryDateCutOffTime:
            state.loginReducer.requestedDeliveryDateCutOffTime,
        currentDateDelivery: state.loginReducer.currentDateDelivery,
    }));

    const normalizeIsInsideTerritory = (value) => {
        if (value === true || value === 'true') return true;
        if (value === false || value === 'false') return false;
        return undefined;
    };
    const normalizedIsInsideTerritory = normalizeIsInsideTerritory(
        isInsideTerritory
    );
    const derivedTerritoryValue =
        normalizedIsInsideTerritory === false
            ? OutsideTerritory()
            : WithinTerritory();

    useEffectWithErrorLogging(() => {
        if (hasManuallySelectedTerritory) return;
        setTerritory(derivedTerritoryValue);
        dispatch(setTerritoryValue(derivedTerritoryValue));
    }, [derivedTerritoryValue, hasManuallySelectedTerritory, dispatch]);
    const [shipToInputValue, setshipToInputValue] = useState(null);

    const RequestDeliveryDate = useSelector(
        (state) => state.reportUsageRootReducer.requestDeliveryDate
    );
    const SurgeryDate = useSelector(
        (state) => state.reportUsageRootReducer.surgeryDate
    );
    const {
        employeeRole,
        countryISOCode,
        requestedDeliveryDateMandatory,
        requestedDeliveryDateVisibility,
    } = useSelector((state) => ({
        employeeRole: state.loginReducer.hybrisUserDetails.employeeRole,
        countryISOCode: state.loginReducer.hybrisUserDetails.countryISOCode,
        requestedDeliveryDateMandatory:
            state.loginReducer?.requestedDeliveryDateMandatory,
        requestedDeliveryDateVisibility:
            state.loginReducer?.requestedDeliveryDateVisibility,
    }));

    const showDistrictAsterisk =
        employeeRole !== CC_USER_ROLE && employeeRole !== CSR_USER_ROLE;

    const {
        billToReportUsageVisibility,
        billToReportUsageMandatory,
        billToShipToPartnerRole,
        attnFieldVisibility,
        transferRecipientVisibility,
        transferRecipientMeta,
        transferRecipientMandatory,
        careOfFieldVisibilityZLCR,
        careOfFieldMandatory,
    } = useSelector((state) => state.loginReducer);

    const DraftBillToId = useSelector(
        (state) =>
            state.reportUsageRootReducer.usageDetails?.products?.[0]
                ?.replenishmentDetails?.billToId
    );

    const { nonTissueAddress, tissueAddress, shipToAddressLoading } =
        useSelector((state) => ({
            nonTissueAddress:
                state.reportShipToAddressReducer.insideShipToAddress
                    .nonTissueAddress,
            tissueAddress:
                state.reportShipToAddressReducer.insideShipToAddress
                    .tissueAddress,
            shipToAddressLoading: state.reportShipToAddressReducer.loading,
        }));

    const {
        accountsOptionLoading,
        physiciansOptionLoading,
        billToLoading,
        transferRecipientLoading,
    } = useSelector((state) => ({
        accountsOptionLoading: state.detailsDropdownsReducer.accounts.loading,
        physiciansOptionLoading:
            state.detailsDropdownsReducer.physicianList.loading,
        billToLoading: state.detailsDropdownsReducer.billToDetails.loading,
        transferRecipientLoading: state.usageTransferRecipientReducer.loading,
    }));

    const { shippingMethod } = useSelector((state) => ({
        shippingMethod:
            state.reportShippingMethodsReducer.insideShippingMethods.S002,
    }));
    const showShippingMethod = useSelector((state) => {
        return state.reportShippingMethodsReducer.showShippingMethods;
    });
    const districtAndTerritory = useSelector(
        (state) => state.reportUsageRootReducer.districtAndTerritory
    );
    const transferRecipient = useSelector(
        (state) => state.usageTransferRecipientReducer.transferRecipient
    );
    const [selectedTerritory, setSelectedTerritory] = useState(
        usageDetails?.territoryId ? usageDetails.territoryId : ''
    );
    const [isFromOutSide, setIsFromOutSide] = useState(false);
    const [selectedDistrict, setSelectedDistrict] = useState(
        usageDetails?.districtId ? usageDetails.districtId : ''
    );
    const [requestDeliveryDate, setRequestDeliveryDate] = useState('');
    const [selectedAccount, setSelectedAccount] = useState('');
    //const [insideAccountDetails, setInsideAccountDetails] = useState(null);
    const [selectedCard, setSelectedCard] = useState('');
    //const [careOfValue, setCareOfValue] = useState('');
    const [enableAddressButton, setEnableAddressButton] = useState(false);
    const [advanceSearchValue, setAdvanceSearchValue] = useState(false);
    const [selectedList, setSelectedList] = useState('');
    const [accountData, setAccountData] = useState('');
    const [numberOfSurgery, setNumberOfSurgery] = useState();
    const [surgeryDate, setSurgeryDate] = useState('');

    const [transferRecipientOptions, setTransferRecipientOptions] =
        useState('');
    const [, setAxiosSource] = useState({});
    const [nextDay, setNextDay] = useState(false);
    const [disableFieldsBillTo, setDisableFieldsBillTo] = useState(false);
    const [surgery_time] = useState('08:00');
    const [accountDetails, setAccountOffSet] = useState('');
    const [time] = useState('AM');
    const [transferRecipientValue, setTransferRecipientValue] = useState('');
    const [transferRecipientSelectedValue, setTransferRecipientSelectedValue] =
        useState('');
    const [openTransferRecipientDropdown, setOpenTransferRecipientDropdown] =
        useState('');
    const [openShipToAddressDropdown, setOpenShipToAddressDropdown] =
        useState('');
    const [isRequestDeliveryMandate, setIsRequestDeliveryMandate] = useState(
        requestedDeliveryDateVisibility === VISIBLE &&
            (requestedDeliveryDateMandatory === 'YES' ||
                requestedDeliveryDateMandatory === 'Yes')
            ? requestDeliveryDate !== ''
            : true
    );
    const physicianSapPartnerId =
        insideAccountDetails?.accountId ||
        selectedAccountId ||
        surgeryDetails?.accountId?.accountId ||
        usageDetails?.accountId ||
        accountId;
    const [isSurgeryDateMandate, setIsSurgeryDateMandate] = useState(
        usageReplenishmentSurgeryDateVisibility === VISIBLE &&
            (usageReplenishmentSurgeryDateMandatoryRule === 'YES' ||
                usageReplenishmentSurgeryDateMandatoryRule === 'Yes'
                ? true
                : false)
            ? surgeryDate !== ''
            : true
    );
    const [isSurgeryNumberMandate] = useState(
        surgeryNumberUsageReplenishmentVisibility === VISIBLE &&
            (surgeryNumberUsageReplenishmentMandatory === 'YES' ||
                surgeryNumberUsageReplenishmentMandatory === 'Yes')
            ? numberOfSurgery !== ''
            : true
    );
    const [shipToAddress, setShipToAddress] = useState({});
    const [billToFieldFlag, setBillToFieldFlag] = useState(false);
    const [attnErrorMsg, setAttnErrorMsg] = useState('');
    const japanMinimunDate = getMinimumDatesBasedOnJapanTime(
        new Date(),
        requestedDeliveryDateCutOffTime,
        surgeryDetails?.accountId
    );
    const businessDays =
        localStorage
            .getItem('businessDays')
            ?.split(',')
            ?.map((date) => parseInt(date)) || [];

    const debouncedGetList = useRef(
        debounce((getList, option) => {
            getList(option);
        }, 500)
    ).current;
    const [defaultPhysicianValue, setDefaultPhysicianValue] = useState('');

    const getPhysicianIdValue = (physician) => {
        if (!physician) return '';
        if (typeof physician === 'string') return physician;
        return physician?.physicianId || '';
    };

    const isFavoritePhysician = (physician) =>
        physician && typeof physician === 'object' && physician?.isFavorite === true;

    const getPhysicianDisplayValue = (physician) =>
        physician?.physicianDisplayName || physician?.physicianId || '';

    const getSavedPhysicianFromGrid = () => {
        const savedRow = gridData?.find(
            (row) => row?.isSelected && row?.physicianId
        );
        return savedRow?.physicianId || null;
    };

    // Handle orientation changes
    useEffectWithErrorLogging(() => {
        const handleOrientationChange = () => {
            const newWidth = window.innerWidth;
            const newHeight = window.innerHeight;

            // Check if orientation actually changed
            if (Math.abs(currentOrientation.width - newWidth) > 100 ||
                Math.abs(currentOrientation.height - newHeight) > 100) {

                setCurrentOrientation({ width: newWidth, height: newHeight });

                // Close any open dropdowns to prevent stale references
                setOpenTransferRecipientDropdown(false);
                setOpenShipToAddressDropdown(false);
            }
        };

        // Listen for orientation change events only
        window.addEventListener('orientationchange', handleOrientationChange);

        return () => {
            window.removeEventListener('orientationchange', handleOrientationChange);
        };
    }, [currentOrientation]);

    useEffectWithErrorLogging(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
            return;
        }
        setRequestDeliveryDate('');
        setShippingMethodValue('');

        setNumberOfSurgery(1);
    }, [selectedAccount, accountData, territory]);

    useEffectWithErrorLogging(() => {
        setAxiosSource(axios.CancelToken.source());
    }, []);
    useEffectWithErrorLogging(() => {
        if (
            shipToAddress !== '' ||
            shipToAddress !== null ||
            shipToAddress !== undefined ||
            shipToInputValue !== undefined
        ) {
            setShipToAddress(shipToAddress);
            // setshipToInputValue(shipToInputValue);
        } else {
            setShipToAddress('');
            // setshipToInputValue('');
        }
    }, [shipToAddress, shipToInputValue]);
    useEffectWithErrorLogging(() => {
        setTransferRecipientOptions(transferRecipient);
    }, [transferRecipient]);
    useEffectWithErrorLogging(() => {
        if (selectedTerritory == '' && selectedDistrict == '') {
            setBillToFieldFlag(true);
        }
    }, []);
    useEffectWithErrorLogging(() => {
        // const selectedAccountId = selectedAccount.split(' ');
        setAccountOffSet(getAccountDetails(selectedItems));
        const requestedDeliveryFromReportUsageObject =
            getRequestDeliveryDateForReplenish(
                gridData,
                selectedItems.map((x) => x.cfn).toString(),
                territory === OutsideTerritory(),
                selectedAccountId
                    ? selectedAccountId
                    : surgeryDetails?.accountId?.accountId
            );
        requestedDeliveryFromReportUsageObject === false
            ? false
            : RequestDeliveryDate && true
                ? setRequestDeliveryDate(RequestDeliveryDate)
                : requestedDeliveryFromReportUsageObject
                    ? setRequestDeliveryDate(requestedDeliveryFromReportUsageObject)
                    : setRequestDeliveryDate('');
        const surgeryDateFromReportUsageObject = getSurgeryDateForReplenish(
            gridData,
            selectedItems.map((x) => x.cfn).toString(),
            territory === OutsideTerritory(),
            selectedAccountId
                ? selectedAccountId
                : surgeryDetails?.accountId?.accountId
        );
        surgeryDateFromReportUsageObject === false
            ? ''
            // !false && setSurgeryDate('')
            : SurgeryDate && true
                ? setSurgeryDate(SurgeryDate)
                : surgeryDateFromReportUsageObject
                    ? setSurgeryDate(surgeryDateFromReportUsageObject)
                    : setSurgeryDate('');
        //  setRequestDeliveryDate('');

        const careOfFieldFromReportUsageObject = getCareOfFieldForReplenish(
            gridData,
            selectedItems.map((x) => x.cfn).toString(),
            territory === OutsideTerritory(),
            selectedAccountId
                ? selectedAccountId
                : surgeryDetails?.accountId?.accountId
        );
        careOfFieldFromReportUsageObject === false
            ? false
            : careOfValue && true
                ? setCareOfValue(careOfValue)
                : careOfFieldFromReportUsageObject
                    ? setCareOfValue(careOfFieldFromReportUsageObject)
                    : setCareOfValue('');
        const transferRecipientFromReportUsageObject =
            getTransferRecipientForReplenish(
                gridData,
                selectedItems.map((x) => x.cfn).toString(),
                territory === OutsideTerritory(),
                selectedAccountId
                    ? selectedAccountId
                    : surgeryDetails?.accountId?.accountId
            );
        transferRecipientFromReportUsageObject === false
            ? false
            : transferRecipientFromReportUsageObject
                ? (handleTransferRecipient(
                    'handleInputChange',
                    'event',
                    transferRecipientFromReportUsageObject
                        ? transferRecipientFromReportUsageObject
                        : '',
                    '',
                    true
                ),
                    handleTransferRecipient(
                        'handleSearch',
                        'event',
                        transferRecipientFromReportUsageObject?.accountName
                            ? transferRecipientFromReportUsageObject?.accountName
                            : '',
                        'reset'
                    ))
                : setTransferRecipientValue('');
        const shipToAddressFromReportUsageObject = getShipToAddressForReplenish(
            gridData,
            selectedItems.map((x) => x.cfn).toString(),
            territory === OutsideTerritory(),
            selectedAccountId
                ? selectedAccountId
                : surgeryDetails?.accountId?.accountId
        );
        const a = nonTissueAddress?.find((item) => {
            return item.shippingAddressId == shipToAddressFromReportUsageObject;
        });
        const shipToAddresstValue1 =
            a?.accountName +
            ' ' +
            accountNumberZeroTrimmer(a?.shippingAddressId);
        shipToAddressFromReportUsageObject === false
            ? false
            : shipToInputValue?.formattedShippingAddressId && true
                ? handleShipToAddress(
                    'handleSearch',
                    'event',
                    shipToInputValue?.formattedShippingAddressId
                        ? shipToInputValue?.formattedShippingAddressId
                        : '',
                    'reset'
                )
                : !hasRestoredShipToRef.current && shipToAddressFromReportUsageObject
                    ? (handleShipToAddress(
                        'handleInputChange',
                        'event',
                        shipToAddressFromReportUsageObject ? a : '',
                        'reset'
                    ),
                        handleShipToAddress(
                            'handleSearch',
                            'event',
                            shipToAddresstValue1 ? shipToAddresstValue1 : '',
                            'reset'
                        ))
                    : '';
    }, [gridData, selectedAccount, accountData, territory, nonTissueAddress]);

    useEffectWithErrorLogging(()=>{
        if (hasRestoredShipToRef.current) return;
        const shipToAddressFromReportUsageObject = getShipToAddressForReplenish(
            gridData,
            selectedItems.map((x) => x.cfn).toString(),
            territory === OutsideTerritory(),
            selectedAccountId
                ? selectedAccountId
                : surgeryDetails?.accountId?.accountId
        );
        const foundIndex = nonTissueAddress?.findIndex((item) => {
            return item.shippingAddressId === shipToAddressFromReportUsageObject;
        });
        setSelectedCard(foundIndex);
    },[nonTissueAddress]);

    useEffectWithErrorLogging(() => {
        if (requestDeliveryDate != '') {
            const picked = new Date(requestDeliveryDate);
            if (Number.isNaN(picked.getTime())) {
                return;
            }
            const dateOnly = new Date(
                picked.getFullYear(),
                picked.getMonth(),
                picked.getDate(),
                0,
                0,
                0,
                0
            );
            setIsRequestDeliveryMandate(true);
            dispatch(storeRequestDeliveryDate(dateOnly));
        } else {
            setIsRequestDeliveryMandate(false);
            dispatch(storeRequestDeliveryDate(''));
        }
    }, [
        requestDeliveryDate,
        surgery_time,
        time,
        accountId,
        surgeryDetails?.accountId?.accountId,
        selectedAccount,
        accountData,
        // OutsideTerritoryDetails?.accountId?.accountId,
        gridData,
    ]);
    useEffectWithErrorLogging(() => {
        if (surgeryDate != '') {
            const picked = new Date(surgeryDate);
            if (Number.isNaN(picked.getTime())) {
                return;
            }
            const dateOnly = new Date(
                picked.getFullYear(),
                picked.getMonth(),
                picked.getDate(),
                0,
                0,
                0,
                0
            );
            setIsSurgeryDateMandate(true);
            dispatch(storeSurgeryDete(dateOnly));
        } else {
            setIsSurgeryDateMandate(false);
            dispatch(storeSurgeryDete(''));
        }
    }, [
        surgeryDate,
        surgery_time,
        time,
        accountId,
        surgeryDetails?.accountId?.accountId,
        selectedAccount,
        accountData,
    ]);
    const getDisable = () => {
        const date = new Date();
        const next = new Date(date);
        next.setDate(date.getDate() + 1);
        next.setHours(0, 0, 0, 0);
        const next2 = new Date(date);
        next2.setDate(date.getDate() + 2);
        next2.setHours(0, 0, 0, 0);
        if (
            new Date(surgeryDate).setHours(0, 0, 0, 0) ===
            new Date().setHours(0, 0, 0, 0)
        ) {
            const date = getDisabledDatesBasedOnJapanTime(
                new Date(surgeryDate),
                true,
                requestedDeliveryDateCutOffTime,
                surgeryDetails?.accountId
            );
            return date ? false : true;
        } else if (
            new Date(surgeryDate).setHours(0, 0, 0, 0) ===
            new Date(next).setHours(0, 0, 0, 0)
        ) {
            const date = getDisabledDatesBasedOnJapanTime(
                new Date(surgeryDate),
                true,
                requestedDeliveryDateCutOffTime,
                surgeryDetails?.accountId
            );
            return date ? false : true;
        } else if (
            new Date(surgeryDate).setHours(0, 0, 0, 0) ===
            new Date(next2).setHours(0, 0, 0, 0)
        ) {
            const date = getDisabledDatesBasedOnJapanTime(
                new Date(surgeryDate),
                true,
                requestedDeliveryDateCutOffTime,
                surgeryDetails?.accountId
            );
            return date ? false : true;
        } else if (
            currentDateDelivery === VISIBLE &&
            new Date(surgeryDate).setHours(0, 0, 0, 0) >=
            new Date().setHours(0, 0, 0, 0)
        ) {
            return true;
        } else if (new Date(surgeryDate) <= new Date()) {
            return false;
        } else return true;
    };
    const handleSurgeryDate = (selectedDate, calledFromDatePicker = false) => {
        if (selectedDate !== '' && selectedDate != null) {
            const leadTime = surgeryDeliveryDateLeadTime;
            if (
                usageReplenishmentSurgeryDateVisibility === VISIBLE &&
                (leadTime !== 'DISABLED' ||
                    countryISOCode === COUNTRY_CODE_JAPN) &&
                (parseInt(leadTime) > 0 || countryISOCode === COUNTRY_CODE_JAPN)
            ) {
                const end = new Date(selectedDate).getTime();
                const start = new Date().getTime();
                const differenceInTimes = Math.abs(end - start);
                const differenceInDays = Math.ceil(
                    differenceInTimes / (1000 * 3600 * 24)
                );

                const upcomingDaysToBeFetched = differenceInDays - 1;

                if (upcomingDaysToBeFetched > 0) {
                    let arrayOfUpcomingDays = [
                        ...Array(upcomingDaysToBeFetched),
                    ].map((date, index) =>
                        convertDateToISOString(
                            moment(selectedDate)
                                .startOf('day')
                                .subtract(index, 'days')
                                .toDate(),
                            'start'
                        )
                    );

                    dispatch(
                        getHolidayList({
                            date: arrayOfUpcomingDays,
                            calculateLastThreeBusinessDays: false,
                            leadTime,
                        })
                    );
                }

                const tomorrow =
                    enableRequestedDeliveryDateForWeekEnd === VISIBLE
                        ? getTomorrowDate([], false)
                        : getTomorrowDate([], true);
                tomorrow.setHours(0, 0, 0, 0);

                if (
                    new Date(
                        new Date(selectedDate).setHours(0, 0, 0, 0)
                    ).getTime() === tomorrow.getTime()
                ) {
                    setNextDay(true);
                } else {
                    setNextDay(false);
                }
            }

            const isPreviousDate =
                new Date(
                    new Date(selectedDate).setHours(0, 0, 0, 0)
                ).getTime() < new Date().setHours(0, 0, 0, 0);

            const isCurrentDate =
                new Date(
                    new Date(selectedDate).setHours(0, 0, 0, 0)
                ).getTime() === new Date().setHours(0, 0, 0, 0);

            if (new Date(selectedDate)) {
                setSurgeryDate(selectedDate);
                calledFromDatePicker
                    ? setRequestDeliveryDate('')
                    : setRequestDeliveryDate(RequestDeliveryDate);
            }
        } else {
            setSurgeryDate('');
            setRequestDeliveryDate('');
            dispatch(storeSurgeryDete(''));
        }
    };

    useEffectWithErrorLogging(() => {
        if (
            numberOfSurgery !== '' &&
            surgeryNumberUsageReplenishmentVisibility === VISIBLE &&
            numberOfSurgery !== undefined
        ) {
            dispatch(setReplenishmentSurgeryNumber(numberOfSurgery));
        }
    }, [numberOfSurgery]);
    useEffectWithErrorLogging(() => {
        const surgeryNumberFromShippingDetails = getSurgeryNumberForReplenish(
            gridData,
            selectedItems.map((x) => x.cfn).toString(),
            territory === OutsideTerritory(),
            selectedAccountId
        );
        surgeryNumberFromShippingDetails &&
            surgeryNumberUsageReplenishmentVisibility === VISIBLE
            ? setNumberOfSurgery(parseInt(surgeryNumberFromShippingDetails))
            : setNumberOfSurgery(1);
    }, [selectedAccount, accountData, territory]);
    useEffectWithErrorLogging(() => {
        if (
            districts &&
            districts?.length === 1 &&
            territories &&
            territories?.length >= 1
        ) {
            setSelectedDistrict(districts[0].districtCode);

            if (territories?.length === 1) {
                setSelectedTerritory(territories[0].terrirotryCode);

                const payloadObj = {
                    district: districts[0].districtCode,
                    territory: territories[0].terrirotryCode,
                    searchParam: '',
                    isReplenishmentPage: true,
                };
                dispatch(getDropdownOptionsRequest('accounts', payloadObj));
            }

            if (territories?.length > 1 && usageDetails?.territoryId) {
                setSelectedTerritory(usageDetails.territoryId);
                const payloadObj = {
                    district: districts[0].districtCode,
                    territory: usageDetails.territoryId,
                    searchParam: '',
                    isReplenishmentPage: true,
                };
                dispatch(getDropdownOptionsRequest('accounts', payloadObj));
            }

            const defaultVal = accounts?.filter(
                (item) => item.accountId === usageDetails?.accountId
            );
            setSelectedAccount(
                defaultVal?.length > 0 && defaultVal[0]?.accountFormattedName
                    ? defaultVal[0].accountFormattedName
                    : ''
            );
            setInsideAccountDetails(
                defaultVal && defaultVal[0] && defaultVal?.length > 0
                    ? defaultVal[0]
                    : null
            );

            if (
                transferRecipientVisibility == VISIBLE &&
                defaultVal?.length > 0
            ) {
                dispatch(
                    getTransferRecipientMethods({
                        sapPartnerId:
                            defaultVal &&
                                defaultVal[0] &&
                                defaultVal?.length > 0
                                ? defaultVal[0]?.accountId
                                : null,
                    })
                );
            }
            if (defaultVal?.length > 0) {
                dispatch(
                    setUsageSurgeryInsideAction({ accountId: defaultVal[0] })
                );
                if (countryISOCode === US_COUNTRY_CODE) {
                    dispatch(clearInsideShippingAddressWhenBillToCleared());
                    setInitialLoad(true);
                }
            }

            const defaultValueUsageDetails = {
                accountId: usageDetails?.accountId || '',
                accountFormattedName: usageDetails?.accountFormattedName || '',
            };
            if (defaultVal?.length == 0) {
                setSelectedAccount(
                    defaultValueUsageDetails?.accountFormattedName
                        ? defaultValueUsageDetails?.accountFormattedName
                        : ''
                );
                setInsideAccountDetails(
                    defaultValueUsageDetails ? defaultValueUsageDetails : null
                );
                dispatch(
                    setUsageSurgeryInsideAction({
                        accountId: defaultValueUsageDetails,
                    })
                );
                if (countryISOCode === US_COUNTRY_CODE) {
                    dispatch(clearInsideShippingAddressWhenBillToCleared());
                    setInitialLoad(true);
                }
            }
        }
    }, [districts, territories]);

    useEffectWithErrorLogging(() => {
        if (usageDetails?.districtId && districts?.length > 1) {
            const payloadObj = {
                districtCode:
                    usageDetails?.districtId &&
                    (usageDetails.districtId === AllDistricts
                        ? ''
                        : usageDetails.districtId
                            ? usageDetails.districtId
                            : districts[0].districtCode),
                searchParam: '',
            };

            dispatch(getDropdownOptionsRequest('territories', payloadObj));
        }
    }, [districts]);

    useEffectWithErrorLogging(() => {
        if (usageDetails?.territoryId) {
            setSelectedTerritory(usageDetails.territoryId);
        }
    }, []);

    useEffectWithErrorLogging(() => {
        if (
            physicianDropdownZGReportUsageReplenishmentVisibility === 'VISIBLE'
        ) {
            if (
                surgeryDetails &&
                Object.prototype.hasOwnProperty.call(
                    surgeryDetails,
                    'physicianId'
                )
            ) {
                return;
            }

            const savedPhysicianFromGrid =
                (Array.isArray(gridData)
                    ? gridData.find(
                        (row) => row?.shippingDetails?.physicianId
                    )?.shippingDetails?.physicianId
                    : null) ||
                (Array.isArray(gridData)
                    ? gridData.find(
                        (row) => row?.replenishmentDetails?.physician
                    )?.replenishmentDetails?.physician
                    : null);

            const normalizePhysician = (physicianValue) => {
                if (!physicianValue) return '';
                if (typeof physicianValue === 'string') {
                    const fromList = Array.isArray(physicianDetails)
                        ? physicianDetails.find(
                            (p) => p?.physicianId === physicianValue
                        )
                        : null;
                    if (fromList) return fromList;

                    if (
                        usageDetails?.physicianId === physicianValue &&
                        usageDetails?.physicianName
                    ) {
                        return {
                            physicianId: physicianValue,
                            physicianDisplayName: usageDetails.physicianName,
                            physicianFormattedName: `${usageDetails.physicianName} ${physicianValue}`,
                        };
                    }

                    return {
                        physicianId: physicianValue,
                        physicianDisplayName: physicianValue,
                        physicianFormattedName: physicianValue,
                    };
                }

                const normalized = { ...physicianValue };
                if (
                    normalized?.physicianId &&
                    !normalized?.physicianDisplayName &&
                    usageDetails?.physicianId === normalized.physicianId &&
                    usageDetails?.physicianName
                ) {
                    normalized.physicianDisplayName = usageDetails.physicianName;
                }
                if (
                    normalized?.physicianId &&
                    normalized?.physicianDisplayName &&
                    !normalized?.physicianFormattedName
                ) {
                    normalized.physicianFormattedName = `${normalized.physicianDisplayName} ${normalized.physicianId}`;
                }
                return normalized;
            };

            const usagePhysician = usageDetails?.physicianId
                ? {
                    physicianId: usageDetails.physicianId,
                    physicianDisplayName: usageDetails?.physicianName || '',
                    physicianFormattedName: `${usageDetails?.physicianName || ''} ${usageDetails.physicianId}`.trim(),
                }
                : '';

            const defaultPhysicianValue1 = normalizePhysician(
                savedPhysicianFromGrid || usagePhysician || ''
            );

            setDefaultPhysicianValue(defaultPhysicianValue1);
            handleInputChangee('physicianId', defaultPhysicianValue1);
            setPhysicianValue(
                defaultPhysicianValue1?.physicianDisplayName || ''
            );
        } else {
            handleInputChangee('physicianId', '');
            handleSearche('', '', 'set', 'physician');
        }
    }, [
        // physicianDropdownZGReportUsageReplenishmentVisibility,
        surgeryDetails?.physicianId,
        // gridData,
        // physicianDetails,
        usageDetails?.physicianId,
        // usageDetails?.physicianName,
    ]);

    useEffectWithErrorLogging(() => {
        if (nonTissueAddress !== undefined) {
            if (nonTissueAddress?.length !== 0) {
                return { nonTissueAddress, ...tissueAddress };
            }
        }
    }, [nonTissueAddress]);

    useEffectWithErrorLogging(() => {
        if (
            surgeryDetails?.accountId !== undefined &&
            surgeryDetails.accountId !== '' &&
            territory !== OutsideTerritory() &&
            surgeryDetails.billToId !== '' &&
            surgeryDetails.billToId !== undefined &&
            shippingMethodInitial
        ) {
            dispatch(getShipToAddress({ isInside: true, searchValue: '' }));
            setShippingMethodValue('');
            setShippingMethodInitial(false);
        } else if (
            surgeryDetails?.accountId !== undefined &&
            surgeryDetails.accountId !== '' &&
            territory !== OutsideTerritory() &&
            billToShipToPartnerRole !== 'BILL_TO'
        ) {
            dispatch(getShipToAddress({ isInside: true, searchValue: '' }));
            setShippingMethodValue('');
        }
    }, [surgeryDetails, territory]);

    useEffectWithErrorLogging(() => {
        if (countryISOCode !== US_COUNTRY_CODE) {
            if (!selectedTerritory || !selectedDistrict) {
                return;
            }
        }
        if (nonTissueAddress !== undefined && !isFromOutSide) {
            if (nonTissueAddress.length === 0) {
                setSelectedCard('');
                setSelectedShipTo('');
                // setshipToInputValue(null);
                setShippingMethodValue('');
                return;
            }

            // Use ref as fallback when selectedShipTo was transiently cleared during address reload
            const effectiveShipTo = selectedShipTo?.shippingAddressId
                ? selectedShipTo
                : initialSelectedShipToRef.current;

            if (nonTissueAddress.length > 1) {
                const hasDefaultAddress = nonTissueAddress.some(
                    (element) => element.defaultAddress
                );

                if (!hasDefaultAddress) {
                    const isSelectedShipToStillValid =
                    Boolean(effectiveShipTo?.shippingAddressId) &&
                        nonTissueAddress.some(
                            (address) =>
                                address?.shippingAddressId ===
                                selectedShipTo?.shippingAddressId
                        );

                    if (!isSelectedShipToStillValid) {
                        setSelectedCard('');
                        setSelectedShipTo('');
                        // setshipToInputValue(null);
                        setShippingMethodValue('');
                    }
                }
            }

            // Check if we have a previously selected ship-to address (from a prior modal session)
            const hasPreviousSelection = effectiveShipTo?.shippingAddressId &&
                nonTissueAddress.some(addr => addr.shippingAddressId === effectiveShipTo.shippingAddressId);     
            if (nonTissueAddress.length !== 0 && nonTissueAddress.length > 1) {
                if (hasPreviousSelection && (initialLoad || !hasRestoredShipToRef.current)) {
                    // Restore the previously selected address instead of selecting default
                    const prevIdx = nonTissueAddress.findIndex(
                        addr => addr.shippingAddressId === effectiveShipTo.shippingAddressId
                    );
                    if (prevIdx >= 0) {
                        const restoredAddr = nonTissueAddress[prevIdx];
                        setshipToInputValue(restoredAddr);
                        setSelectedCard(prevIdx);
                        setShipToAddress(restoredAddr);
                        setSelectedShipTo(restoredAddr);
                        hasRestoredShipToRef.current = true;
                        initialSelectedShipToRef.current = null;
                        let shippingPayload = {
                            orderType: 'ZLC',
                            shipToAcc: restoredAddr?.shippingAddressId || null,
                            salesOrg: restoredAddr?.salesOrg,
                            isOutside: false,
                            surgeryDate: SurgeryDate ? getRddDate(SurgeryDate) : '',
                            requestDeliveryDate:
                                countryISOCode !== 'US'
                                    ? RequestDeliveryDate
                                        ? getRddDate(RequestDeliveryDate)
                                        : ''
                                    : '',
                            currentDate: getJapanCurrentDateTime(
                                surgeryDetails?.accountId?.timeZoneOffset,
                                surgeryDetails?.accountId?.accountTimeZone,
                                true
                            ),
                            requestedDeliveryDateMandatoryRule:
                                countryISOCode !== 'US'
                                    ? requestedDeliveryDateMandatory === 'YES'
                                        ? 'YES'
                                        : 'NO'
                                    : '',
                            requestedDeliveryDateVisbility:
                                countryISOCode !== 'US'
                                    ? requestedDeliveryDateVisibility === VISIBLE
                                        ? 'YES'
                                        : 'NO'
                                    : '',
                        };
                        dispatch(getShippingMethods(shippingPayload));
                    }
                    setInitialLoad(false);
                } else {
                nonTissueAddress.forEach((element, index) => {
                    if (element.defaultAddress) {
                        if (initialLoad) {
                            setshipToInputValue(element);
                            handleShippingToCardClick(
                                element,
                                element.accountId
                            );
                            setInitialLoad(false);
                        }
                    if (!hasRestoredShipToRef.current) {
                        let shippingPayload = {
                            orderType: 'ZLC',
                            shipToAcc: element?.shippingAddressId
                                ? element.shippingAddressId
                                : null,
                            salesOrg: element.salesOrg,
                            isOutside: false,
                            surgeryDate: SurgeryDate
                                ? getRddDate(SurgeryDate)
                                : '',
                            requestDeliveryDate:
                                countryISOCode !== 'US'
                                    ? RequestDeliveryDate
                                        ? getRddDate(RequestDeliveryDate)
                                        : ''
                                    : '',
                            currentDate: getJapanCurrentDateTime(
                                surgeryDetails?.accountId?.timeZoneOffset,
                                surgeryDetails?.accountId?.accountTimeZone,
                                true
                            ),
                            requestedDeliveryDateMandatoryRule:
                                countryISOCode !== 'US'
                                    ? requestedDeliveryDateMandatory === 'YES'
                                        ? 'YES'
                                        : 'NO'
                                    : '',
                            requestedDeliveryDateVisbility:
                                countryISOCode !== 'US'
                                    ? requestedDeliveryDateVisibility ===
                                        VISIBLE
                                        ? 'YES'
                                        : 'NO'
                                    : '',
                        };

                        setShipToAddress(element);
                        setSelectedCard(index);
                        setSelectedShipTo(element);
                        dispatch(getShippingMethods(shippingPayload));
                        hasRestoredShipToRef.current = true;
                        }
                    }
                });
                }
            } else if (
                nonTissueAddress.length !== 0 &&
                nonTissueAddress.length === 1
            ) {
                if (hasPreviousSelection && (initialLoad || !hasRestoredShipToRef.current)) {
                    // Restore the previously selected single address
                    const restoredAddr = nonTissueAddress[0];
                    setshipToInputValue(restoredAddr);
                    setSelectedCard(0);
                    setShipToAddress(restoredAddr);
                    setSelectedShipTo(restoredAddr);
                    hasRestoredShipToRef.current = true;
                    initialSelectedShipToRef.current = null;
                    let shippingPayload = {
                        orderType: 'ZLC',
                        shipToAcc: restoredAddr?.shippingAddressId || null,
                        salesOrg: restoredAddr?.salesOrg,
                        isOutside: false,
                        surgeryDate: SurgeryDate ? getRddDate(SurgeryDate) : '',
                        requestDeliveryDate:
                            countryISOCode !== 'US'
                                ? RequestDeliveryDate
                                    ? getRddDate(RequestDeliveryDate)
                                    : ''
                                : '',
                        currentDate: getJapanCurrentDateTime(
                            surgeryDetails?.accountId?.timeZoneOffset,
                            surgeryDetails?.accountId?.accountTimeZone,
                            true
                        ),
                        requestedDeliveryDateMandatoryRule:
                            countryISOCode !== 'US'
                                ? requestedDeliveryDateMandatory === 'YES'
                                    ? 'YES'
                                    : 'NO'
                                : '',
                        requestedDeliveryDateVisbility:
                            countryISOCode !== 'US'
                                ? requestedDeliveryDateVisibility === VISIBLE
                                    ? 'YES'
                                    : 'NO'
                                : '',
                    };
                    dispatch(getShippingMethods(shippingPayload));
                    setInitialLoad(false);
                } else {
                let shippingPayload = {
                    orderType: 'ZLC',
                    shipToAcc: nonTissueAddress[0]?.shippingAddressId
                        ? nonTissueAddress[0].shippingAddressId
                        : null,
                    salesOrg: nonTissueAddress[0]?.salesOrg,
                    isOutside: false,
                    surgeryDate: SurgeryDate ? getRddDate(SurgeryDate) : '',
                    requestDeliveryDate:
                        countryISOCode !== 'US'
                            ? RequestDeliveryDate
                                ? getRddDate(RequestDeliveryDate)
                                : ''
                            : '',
                    currentDate: getJapanCurrentDateTime(
                        surgeryDetails?.accountId?.timeZoneOffset,
                        surgeryDetails?.accountId?.accountTimeZone,
                        true
                    ),
                    requestedDeliveryDateMandatoryRule:
                        countryISOCode !== 'US'
                            ? requestedDeliveryDateMandatory === 'YES'
                                ? 'YES'
                                : 'NO'
                            : '',
                    requestedDeliveryDateVisbility:
                        countryISOCode !== 'US'
                            ? requestedDeliveryDateVisibility === VISIBLE
                                ? 'YES'
                                : 'NO'
                            : '',
                };

                if (initialLoad && shipToInputValue === null) {
                    setshipToInputValue(nonTissueAddress[0]);
                    handleShippingToCardClick(
                        nonTissueAddress[0],
                        nonTissueAddress[0].accountId
                    );
                    setInitialLoad(false);
                }
                if (!hasRestoredShipToRef.current && shipToInputValue === null) {
                    setShipToAddress('');
                    setSelectedCard(0);
                    setSelectedShipTo(nonTissueAddress[0]);
                    dispatch(getShippingMethods(shippingPayload));
                    hasRestoredShipToRef.current = true;
                }
            }
            }
            if (
                nonTissueAddress.length !== 0 &&
                (requestedDeliveryDateMandatory === 'YES'
                    ? RequestDeliveryDate
                    : true)
            ) {
                if (selectedShipTo?.shippingAddressId) {
                    dispatch(
                        getShippingMethods({
                            orderType: 'ZLC',
                            shipToAcc: selectedShipTo?.shippingAddressId
                                ? selectedShipTo?.shippingAddressId
                                : null,

                            salesOrg: salesOrg ? salesOrg : null,
                            isOutside: false,
                            surgeryDate: SurgeryDate
                                ? getRddDate(SurgeryDate)
                                : '',
                            requestDeliveryDate:
                                countryISOCode !== 'US'
                                    ? RequestDeliveryDate
                                        ? getRddDate(RequestDeliveryDate)
                                        : ''
                                    : '',
                            currentDate: getJapanCurrentDateTime(
                                surgeryDetails?.accountId?.timeZoneOffset,
                                surgeryDetails?.accountId?.accountTimeZone,
                                true
                            ),
                            requestedDeliveryDateMandatoryRule:
                                countryISOCode !== 'US'
                                    ? requestedDeliveryDateMandatory === 'YES'
                                        ? 'YES'
                                        : 'NO'
                                    : '',
                            requestedDeliveryDateVisbility:
                                countryISOCode !== 'US'
                                    ? requestedDeliveryDateVisibility ===
                                        VISIBLE
                                        ? 'YES'
                                        : 'NO'
                                    : '',
                        })
                    );
                }
            }
        }
    }, [
        nonTissueAddress,
        RequestDeliveryDate,
        surgeryDetails?.accountId?.accountId,
        selectedTerritory,
        selectedDistrict,
    ]);

    useEffectWithErrorLogging(() => {
        if (countryISOCode !== US_COUNTRY_CODE) {
            if (!selectedTerritory || !selectedDistrict) {
                return;
            }
            if (
                usageDetails?.accountId &&
                accounts?.length > 0 &&
                selectedAccount === '' &&
                !hasAutoPopulatedAccountRef.current
            ) {
                hasAutoPopulatedAccountRef.current = true;
                const defaultVal = accounts.filter(
                    (item) => item.accountId === usageDetails?.accountId
                );
                setSelectedAccount(
                    defaultVal?.length > 0 && defaultVal[0]?.accountFormattedName
                        ? defaultVal[0].accountFormattedName
                        : ''
                );
                setInsideAccountDetails(
                    defaultVal[0] && defaultVal?.length > 0 ? defaultVal[0] : null
                );
                if (transferRecipientVisibility == VISIBLE) {
                    dispatch(
                        getTransferRecipientMethods({
                            sapPartnerId: defaultVal[0]?.accountId,
                        })
                    );
                }
                if (defaultVal.length > 0) {
                    dispatch(
                        setUsageSurgeryInsideAction({ accountId: defaultVal[0] })
                    );
                }
                const defaultValueUsageDetails = {
                    accountId: usageDetails?.accountId || '',
                    accountFormattedName: usageDetails?.accountFormattedName || '',
                };
                if (defaultVal.length == 0) {
                    setSelectedAccount(
                        defaultValueUsageDetails?.accountFormattedName
                            ? defaultValueUsageDetails?.accountFormattedName
                            : ''
                    );
                    setInsideAccountDetails(
                        defaultValueUsageDetails ? defaultValueUsageDetails : null
                    );
                    dispatch(
                        setUsageSurgeryInsideAction({
                            accountId: defaultValueUsageDetails,
                        })
                    );
                    }
                }
            return () => {
                if (
                    !usageDetails.changeAccountEnabled ||
                    isInsideTerritory === true ||
                    isInsideTerritory === undefined
                ) {
                    dispatch(setSelectedOutsideAccount(''));
                    dispatch(clearOutsideShippingAddress());
                }
            };
        }
        // US path
        if (
            usageDetails?.accountId &&
            accounts?.length > 0 &&
            selectedAccount === '' &&
            !hasAutoPopulatedAccountRef.current
        ) {
            hasAutoPopulatedAccountRef.current = true;
            const defaultVal = accounts.filter(
                (item) => item.accountId === usageDetails?.accountId
            );
            setSelectedAccount(
                defaultVal?.length > 0 && defaultVal[0]?.accountFormattedName
                    ? defaultVal[0].accountFormattedName
                    : ''
            );
            setInsideAccountDetails(
                defaultVal[0] && defaultVal?.length > 0 ? defaultVal[0] : null
            );
            if (transferRecipientVisibility == VISIBLE) {
                dispatch(
                    getTransferRecipientMethods({
                        sapPartnerId: defaultVal[0]?.accountId,
                    })
                );
            }

            if (defaultVal.length > 0) {
                dispatch(
                    setUsageSurgeryInsideAction({ accountId: defaultVal[0] })
                );
                if (countryISOCode === US_COUNTRY_CODE) {
                    dispatch(clearInsideShippingAddressWhenBillToCleared());
                    setInitialLoad(true);
                }
            }

            const defaultValueUsageDetails = {
                accountId: usageDetails?.accountId || '',
                accountFormattedName: usageDetails?.accountFormattedName || '',
            };
            if (defaultVal.length == 0) {
                setSelectedAccount(
                    defaultValueUsageDetails?.accountFormattedName
                        ? defaultValueUsageDetails?.accountFormattedName
                        : ''
                );
                setInsideAccountDetails(
                    defaultValueUsageDetails ? defaultValueUsageDetails : null
                );
                dispatch(
                    setUsageSurgeryInsideAction({
                        accountId: defaultValueUsageDetails,
                    })
                );
                if (countryISOCode === US_COUNTRY_CODE) {
                    dispatch(clearInsideShippingAddressWhenBillToCleared());
                    setInitialLoad(true);
                }
            }
        }
    }, [accounts]);

    useEffectWithErrorLogging(() => {
        if (
            transferRecipientVisibility == VISIBLE &&
            insideAccountDetails?.accountId
        ) {
            dispatch(
                getTransferRecipientMethods({
                    sapPartnerId: insideAccountDetails?.accountId,
                })
            );
        }
    }, [selectedAccount, accounts]);

    useEffectWithErrorLogging(() => {
        if (billToDetails) {
            if (billToDetails.length == 1) {
                setSelectedBillTo(
                    billToDetails[0].billToFormattedName
                        ? billToDetails[0].billToFormattedName
                        : ''
                );
                setSelectedBillToId(billToDetails[0]);
                const object = {
                    ['billToId']: billToDetails[0],
                };
                dispatch(setUsageSurgeryInsideAction(object));
            } else if (billToDetails.length === 0 && countryISOCode !== US_COUNTRY_CODE) {
                setSelectedBillTo('');
                setSelectedBillToId(undefined);
                dispatch(setUsageSurgeryInsideAction({ billToId: undefined }));
            }
        }
    }, [billToDetails, territory]);

    useEffectWithErrorLogging(() => {
        if (billToDetails?.length > 0 && billToInitialState) {
            if (DraftBillToId) {
                const selectedBillToArray1 = billToDetails.filter((item) => {
                    return item.billToNumber == DraftBillToId;
                });
                setSelectedBillTo(
                    selectedBillToArray1[0]
                        ? selectedBillToArray1[0]?.billToFormattedName
                        : ''
                );
                setSelectedBillToId(selectedBillToArray1[0]);
                setBillToInitialState(false);
                dispatch(
                    setUsageSurgeryInsideAction({
                        billToId: selectedBillToArray1[0],
                    })
                );
            } else {
                const selectedBillToArray2 = billToDetails.filter((item) => {
                    return item.billToNumber == usageDetails.billToId;
                });
                setSelectedBillTo(
                    selectedBillToArray2[0]
                        ? selectedBillToArray2[0]?.billToFormattedName
                        : ''
                );
                setSelectedBillToId(selectedBillToArray2[0]);
                setBillToInitialState(false);
                dispatch(
                    setUsageSurgeryInsideAction({
                        billToId: selectedBillToArray2[0],
                    })
                );
            }
        }
    }, [billToDetails]);

    useEffectWithErrorLogging(() => {
        if (shippingMethod && shippingMethod.length) {
            let defaultVal =
                countryISOCode === COUNTRY_CODE_JAPN
                    ? { salesOrg: shippingMethod[0]?.salesOrg }
                    : shippingMethod[0];

            shippingMethod.forEach((element) => {
                if (element.isDefaultSelected) {
                    defaultVal = element;
                }
            });

            defaultShippingMethodRef.current = defaultVal?.isDefaultSelected
                ? defaultVal
                : null;
            defaultVal?.isDefaultSelected && setUsageTransferRecipient('');
            const attnLineDefault =
                shippingMethod &&
                shippingMethod.filter((item) => item.attnLine);
            setAttnValue(
                attnLineDefault.length > 0 ? attnLineDefault[0].attnLine : ''
            );

            const shippingMethodFromReportUsageObject =
                getShippingMethodReplenish(
                    gridData,
                    selectedItems.map((x) => x.cfn).toString(),
                    territory === OutsideTerritory(),
                    selectedAccountId
                        ? selectedAccountId
                        : surgeryDetails?.accountId?.accountId
                );

            setShippingMethodValue(
                shippingMethod.find(m => m.shippingMethodId === initialShippingMethodRef.current?.shippingMethodId)
                || (initialShippingMethodRef.current !== null && shippingMethodFromReportUsageObject && shippingMethodFromReportUsageObject !== false
                    ? (typeof shippingMethodFromReportUsageObject === 'object'
                        ? shippingMethodFromReportUsageObject
                        : shippingMethod.find(m => m.shippingMethodId === shippingMethodFromReportUsageObject))
                    : null)
                || (defaultVal?.isDefaultSelected
                    ? defaultVal
                    : countryISOCode === COUNTRY_CODE_JAPN
                        ? (initialShippingMethodRef.current !== null && shippingMethodFromReportUsageObject || null)
                        : shippingMethod[0])
            );
        }
    }, [shippingMethod]);
    const [physiciantype, setPhysicianType] = useState('favorites');
    const [physicianInputValue, setPhysicianValue] = useState('');
    const [initialFavoritesRequested, setInitialFavoritesRequested] =
        useState(false);
    const hasAppliedInitialFavoriteSelectionRef = useRef(false);
    const shouldEvaluateInitialFavoritesFallbackRef = useRef(false);
    const hasInitialFavoritesLoadStartedRef = useRef(false);
    const initialSearchedWithAllRef = useRef(false);
    const [disableFormFields, setDisableFormFields] = useState(false);
    const [loadAllPhysician, setloadAllPhysician] = useState(false);

    const [expandedCard, setExpandedCard] = useState({
        district:
            !selectedTerritory ||
            (!selectedDistrict && !districts[0]?.districtName),
        shipping: usageDetails?.accountName ? true : false,
    });

    const isMobile = window.innerWidth <= sizes.mobileDevice;

    //latest
    const [selectedBillTo, setSelectedBillTo] = useState('');
    const [billToInitialState, setBillToInitialState] = useState(true);

    const toggleCard = (name, value) => {
        setExpandedCard({
            ...expandedCard,
            [name]: value,
        });
    };

    const handleInputChange = (territory, value) => {
        if (value) {
            setRequestDeliveryDate('');
            setNumberOfSurgery(1);
            setSelectedCard('');
            setSelectedShipTo('');
            setShippingMethodValue('');
        }
        setHasManuallySelectedTerritory(true);
        value === WithinTerritory()
            ? setIsFromOutSide(false)
            : setIsFromOutSide(true);
        setTerritory(value);
        dispatch(setTerritoryValue(value));
    };
    const setFormValues = (selectedField, fieldname) => {
        if (fieldname === 'district') {
            const payloadObj = {
                districtCode:
                    selectedField?.districtId &&
                    (selectedField.districtId === AllDistricts
                        ? ''
                        : selectedField.districtId),
                searchParam: '',
            };
            dispatch(getDropdownOptionsRequest('territories', payloadObj));
        }
        //calling account related to districtId and territoryId
        if (selectedField?.terrirotryCode) {
            setSelectedTerritory(selectedField.terrirotryCode);
            const payloadObj = {
                district:
                    surgeryDetails?.districtId != ''
                        ? surgeryDetails.districtId
                        : usageDetails.districtId,
                territory: selectedField.terrirotryCode,
                searchParam: '',
                isReplenishmentPage: true,
            };
            dispatch(getDropdownOptionsRequest('accounts', payloadObj));
        }
        dispatch(setUsageSurgeryInsideAction(selectedField));
    };

    useEffectWithErrorLogging(() => {
        if (billToReportUsageVisibility == 'VISIBLE') {
            const data = {
                district: usageDetails.districtId
                    ? usageDetails.districtId
                    : selectedDistrict ? selectedDistrict
                        : 'ALL_Districts',
                territory: usageDetails.territoryId
                    ? usageDetails.territoryId
                    : selectedTerritory ? selectedTerritory
                        : 'All_Territories',
                sapPartnerId: accountId,
            };
            dispatch(getDropdownOptionsRequest('billToDetails', data));
        }
    }, []);

    const onDistrictChange = (value) => {
        setSelectedDistrict(value.districtId);
        setSelectedTerritory('');
        setFormValues(value, 'district');
        setFormValues({
            territoryId: '',
            accountId: '',
            caseCoverageId: '',
        });
        setSelectedAccount('');
        setInsideAccountDetails(null);
        if (countryISOCode === US_COUNTRY_CODE) {
            dispatch(clearInsideShippingAddressWhenBillToCleared());
            hasRestoredShipToRef.current = false;
            initialSelectedShipToRef.current = null;
            setSelectedCard('');
            setSelectedShipTo('');
            setshipToInputValue(null);
            setShippingMethodValue('');
        } else {
            setSelectedBillTo('');
            setSelectedBillToId(undefined);
            setBillToInitialState(true);
            dispatch(setUsageSurgeryInsideAction({ billToId: undefined }));
            dispatch(clearInsideShippingAddressWhenBillToCleared());
            hasRestoredShipToRef.current = false;
            initialSelectedShipToRef.current = null;
            setSelectedCard('');
            setSelectedShipTo('');
            setshipToInputValue(null);
            setShippingMethodValue('');
        }
        dispatch(
            clearSingleDropDownList({
                name: 'accounts',
            })
        );
        dispatch(
            clearSingleDropDownList({
                name: 'territories',
            })
        );
        const payloadObj = {
            districtCode:
                value?.districtId &&
                (value.districtId === AllDistricts ? '' : value.districtId),
            searchParam: '',
        };
        dispatch(getDropdownOptionsRequest('territories', payloadObj));
        dispatch(setUsageSurgeryInsideAction(value));
    };
    const onTerritoryChange = (value) => {
        setSelectedTerritory(value.terrirotryCode);
        setFormValues(value);
        setFormValues({
            accountId: '',
            caseCoverageId: '',
        });
        setSelectedAccount('');
        setInsideAccountDetails(null);
        if (countryISOCode === US_COUNTRY_CODE) {
            dispatch(clearInsideShippingAddressWhenBillToCleared());
            hasRestoredShipToRef.current = false;
            initialSelectedShipToRef.current = null;
            setSelectedCard('');
            setSelectedShipTo('');
            setshipToInputValue(null);
            setShippingMethodValue('');
        } else {
            setSelectedBillTo('');
            setSelectedBillToId(undefined);
            setBillToInitialState(true);
            dispatch(setUsageSurgeryInsideAction({ billToId: undefined }));
             dispatch(clearInsideShippingAddressWhenBillToCleared());
            hasRestoredShipToRef.current = false;
            initialSelectedShipToRef.current = null;
            setSelectedCard('');
            setSelectedShipTo('');
            setshipToInputValue(null);
            setShippingMethodValue('');
        }
        dispatch(
            clearSingleDropDownList({
                name: 'accounts',
            })
        );
        dispatch(
            clearSingleDropDownList({
                name: 'caseCoverageEmployees',
            })
        );
        const payloadObj = {
            district: usageDetails?.districtId,
            territory: value.terrirotryCode,
            searchParam: '',
            isReplenishmentPage: true,
        };
        dispatch(getDropdownOptionsRequest('accounts', payloadObj));
    };

    const { salesOrg } = useSelector((state) => ({
        salesOrg: state.loginReducer.salesOrg,
    }));
    const [disableFields, setDisableFields] = useState({
        account: false,
        physician: false,
        template: false,
        billToId: false,
        // physicianTextBox: physicianTextBoxType === 'unknown',
    });

    const emptyAddressObj = {
        addressId: '',
        salesOrg: '',
        attention: '',
        shippingAddressId: '',
        formattedShippingAddressId: '',
    };

    const showOptionsAfterClose = (value) => {
        setTimeout(() => {
            try {
                handleDisableField(value, true);
            } catch (error) {
                logErrorToConsole(error);
            }
        }, 700);
    };
    const handleDisableField = (fieldName, value) => {
        setDisableFields({
            ...disableFields,
            [fieldName]: value,
        });
    };
    const handleInputChangee = (name, value) => {
        if (name == 'physicianId') {
            if (initialFavoritesRequested) {
                getPhysicanList({
                    isLoadAll: false,
                    searchValue: value,
                    type: physiciantype === 'favorites' ? 'favorites' : 'All',
                    sapPartnerId: physicianSapPartnerId,
                });
            }
            dispatch(
                setUsageSurgeryInsideAction({
                    physicianId: value,
                })
            );
            return;
        }
    };
    // const{ physicianId} = surgeryDetailss;
    const getPhysicanList = (data) => {
        const { searchValue, isLoadAll, forceLoadAll, sapPartnerId } = data;

        const resolvedSapPartnerId = sapPartnerId || physicianSapPartnerId;
        const resolvedSearchTerm =
            typeof searchValue === 'string'
                ? searchValue
                : searchValue?.physicianDisplayName ||
                  searchValue?.physicianId ||
                  '';

        let params = {
            physicianType: data.type
                ? data.type
                : physiciantype == 'favorites'
                    ? 'favorites'
                    : 'All',
            isLoadAll:
                forceLoadAll ?? searchLoadAll ? searchLoadAll : isLoadAll,
            searchTerm: resolvedSearchTerm,
            sapPartnerId: resolvedSapPartnerId,
        };
        if (params.physicianType === 'All') {
            setloadAllPhysician(true);
        } else {
            setloadAllPhysician(false);
        }
        dispatch(
            getDropdownOptionsRequest(
                'physicians',
                params,
                salesOrg,
                countryISOCode
            )
        );
    };
    const [searchLoadAll, setSearchLoadAll] = useState(false);
    const handleLoadAll = (loadAnimation) => {
        // setPhysicianValue('');
        setSearchLoadAll(true);
        getPhysicanList({
            searchValue: '',
            isLoadAll: true,
            type: physiciantype === 'favorites' ? 'favorites' : 'All',
            sapPartnerId: physicianSapPartnerId,
        });
    };
    const AccountTemplatee = (option, fieldname, physiciantype, inputValue) => {
        return (
            <AccountPhysicianTemplate
                option={option}
                data={physicianDetails || []}
                optionValue={'physicianId'}
                fieldname={fieldname}
                onLoadMore={() => handleLoadAll(true)}
                showLoadMore={loadAllPhysician}
                showOptionLoader={false}
                physiciantype={physiciantype}
                physicianInputValue={inputValue}
            />
        );
    };
    const physicianTypeChange = (type, fromSwitch = false) => {
        setPhysicianType(type);
        setSearchLoadAll(false);
        if (!fromSwitch) {
            setPhysicianValue('');
            setDefaultPhysicianValue('');
            dispatch(
                setUsageSurgeryInsideAction({
                    physicianId: '',
                })
            );
            handleDisableField('physician', true);
        }
        dispatch(
            clearSingleDropDownList({
                name: 'physicians',
            })
        );

        getPhysicanList({
            forceLoadAll: false,
            searchValue: '',
            isLoadAll: false,
            type: type === 'favorites' ? 'favorites' : 'All',
            sapPartnerId: physicianSapPartnerId,
        });
    };

    useEffectWithErrorLogging(() => {
        if (
            physicianDropdownZGReportUsageReplenishmentVisibility ===
            'VISIBLE' &&
            physiciantype === 'favorites' &&
            physicianSapPartnerId &&
            !initialFavoritesRequested
        ) {
            shouldEvaluateInitialFavoritesFallbackRef.current = true;
            hasInitialFavoritesLoadStartedRef.current = false;
            setInitialFavoritesRequested(true);
            dispatch(
                clearSingleDropDownList({
                    name: 'physicians',
                })
            );
            const existingPhysicianId = usageDetails?.physicianId || surgeryDetails?.physicianId?.physicianId || '';
            const existingPhysicianName = usageDetails?.physicianName || surgeryDetails?.physicianId?.physicianDisplayName || '';
            if (existingPhysicianId) {
                initialSearchedWithAllRef.current = true;
                getPhysicanList({
                    forceLoadAll: false,
                    searchValue: existingPhysicianName || existingPhysicianId,
                    isLoadAll: false,
                    type: 'All',
                    sapPartnerId: physicianSapPartnerId,
                });
            } else {
                initialSearchedWithAllRef.current = false;
                getPhysicanList({
                    forceLoadAll: false,
                    searchValue: '',
                    isLoadAll: false,
                    type: 'favorites',
                    sapPartnerId: physicianSapPartnerId,
                });
            }
        }
    }, [
        physicianDropdownZGReportUsageReplenishmentVisibility,
        physiciantype,
        physicianSapPartnerId,
        initialFavoritesRequested,
    ]);

    useEffectWithErrorLogging(() => {
        if (!shouldEvaluateInitialFavoritesFallbackRef.current) return;
        if (!initialFavoritesRequested) return;
        if (physiciansOptionLoading) {
            hasInitialFavoritesLoadStartedRef.current = true;
        }
    }, [initialFavoritesRequested, physiciansOptionLoading]);

    useEffectWithErrorLogging(() => {
        if (hasAppliedInitialFavoriteSelectionRef.current) return;
        if (!initialFavoritesRequested && physiciantype !== 'favorites') {
            return;
        }
        if (physiciansOptionLoading) return;

        const favoritePhysicians = Array.isArray(physicianDetails)
            ? (physiciantype === 'favorites' && initialFavoritesRequested && !initialSearchedWithAllRef.current
                ? physicianDetails  // All returned are favorites when requested with type='favorites'
                : physicianDetails.filter(isFavoritePhysician))
            : [];

        if (favoritePhysicians.length === 0) {
            // When searched with 'All' and physician exists but is not a favorite, switch to All/Territory
            if (initialSearchedWithAllRef.current && Array.isArray(physicianDetails) && physicianDetails.length > 0) {
                hasAppliedInitialFavoriteSelectionRef.current = true;
                shouldEvaluateInitialFavoritesFallbackRef.current = false;
                initialSearchedWithAllRef.current = false;
                if (physiciantype === 'favorites') {
                    physicianTypeChange('All', true);
                }
            }
            return;
        }

        const savedPhysicianFromGrid = getSavedPhysicianFromGrid();
        const savedGridPhysicianId = getPhysicianIdValue(
            savedPhysicianFromGrid
        );
        const currentSelectedPhysicianId = getPhysicianIdValue(
            surgeryDetails?.physicianId
        );
        const favoritePhysicianIds = new Set(
            favoritePhysicians.map((physician) => physician?.physicianId)
        );

        const isCurrentSelectionFavorite = 
            isFavoritePhysician(surgeryDetails?.physicianId) ||
            (currentSelectedPhysicianId && favoritePhysicianIds.has(currentSelectedPhysicianId));
        
        const shouldPreserveExistingSelection =
            (!!savedGridPhysicianId &&
                !favoritePhysicianIds.has(savedGridPhysicianId)) ||
            (!!currentSelectedPhysicianId &&
                currentSelectedPhysicianId !== usageDetails?.physicianId &&
                !favoritePhysicianIds.has(currentSelectedPhysicianId) &&
                !isCurrentSelectionFavorite) ||
            (initialSearchedWithAllRef.current &&
                !!currentSelectedPhysicianId &&
                !isCurrentSelectionFavorite);

        if (shouldPreserveExistingSelection) {
            hasAppliedInitialFavoriteSelectionRef.current = true;
            shouldEvaluateInitialFavoritesFallbackRef.current = false;
            initialSearchedWithAllRef.current = false;

            if (physiciantype === 'favorites') {
                physicianTypeChange('All', true);
            }
            return;
        }

        const currentPhysicianId =
            currentSelectedPhysicianId ||
            getPhysicianIdValue(defaultPhysicianValue) ||
            usageDetails?.physicianId ||
            '';

        const nextFavoritePhysician =
            (savedGridPhysicianId
                ? favoritePhysicians.find(
                      (physician) =>
                          physician?.physicianId === savedGridPhysicianId
                  )
                : null) ||
            favoritePhysicians.find(
                (physician) => physician?.physicianId === currentPhysicianId
            ) || favoritePhysicians[0];

        if (!nextFavoritePhysician) return;

        hasAppliedInitialFavoriteSelectionRef.current = true;
        shouldEvaluateInitialFavoritesFallbackRef.current = false;
        initialSearchedWithAllRef.current = false;

        if (physiciantype !== 'favorites') {
            setPhysicianType('favorites');
        }

        setDefaultPhysicianValue(nextFavoritePhysician);
        setPhysicianValue(getPhysicianDisplayValue(nextFavoritePhysician));

        if (
            getPhysicianIdValue(surgeryDetails?.physicianId) !==
                nextFavoritePhysician?.physicianId ||
            !isFavoritePhysician(surgeryDetails?.physicianId)
        ) {
            dispatch(
                setUsageSurgeryInsideAction({
                    physicianId: nextFavoritePhysician,
                })
            );
        }
    }, [
        initialFavoritesRequested,
        physiciantype,
        physiciansOptionLoading,
        physicianDetails,
        surgeryDetails?.physicianId,
        defaultPhysicianValue,
        gridData,
        usageDetails?.physicianId,
        dispatch,
    ]);

    useEffectWithErrorLogging(() => {
        if (!shouldEvaluateInitialFavoritesFallbackRef.current) return;
        if (!initialFavoritesRequested) return;
        if (physiciantype !== 'favorites') return;
        if (physiciansOptionLoading) return;
        if (!hasInitialFavoritesLoadStartedRef.current) return;

        const favoritesEmpty =
            !Array.isArray(physicianDetails) || physicianDetails.length === 0;
        if (!favoritesEmpty) return;

        const hasPersistedOrSelectedPhysician =
            !!surgeryDetails?.physicianId?.physicianId ||
            !!defaultPhysicianValue?.physicianId ||
            !!usageDetails?.physicianId;

        // Only clear if nothing is set anywhere.
        if (!hasPersistedOrSelectedPhysician) {
            setPhysicianValue('');
            setDefaultPhysicianValue('');
            dispatch(
                setUsageSurgeryInsideAction({
                    physicianId: '',
                })
            );
        }
        hasAppliedInitialFavoriteSelectionRef.current = true;
        shouldEvaluateInitialFavoritesFallbackRef.current = false;
        physicianTypeChange('All', true);
    }, [
        initialFavoritesRequested,
        physiciantype,
        physiciansOptionLoading,
        physicianDetails,
        usageDetails?.physicianId,
        surgeryDetails?.physicianId,
        defaultPhysicianValue,
    ]);

    const handleSearche = (event, value, reason, fieldname) => {
        if (reason !== 'reset') {
            let option = {
                searchValue: value?.trim() || '',
                sapPartnerId: physicianSapPartnerId,
            };
            if (fieldname == 'physician') {
                setPhysicianValue(value);
                debouncedGetList(getPhysicanList, option);
            }
        } else {
            if (fieldname == 'physician') {
                setPhysicianValue(value);
                handleInputChangee(
                    'physicianDropDown',
                    physiciantype === 'favorites' ? 'Favorites' : 'All'
                );
                getPhysicanList({
                    isLoadAll: false,
                    searchValue: '',
                    type: physiciantype === 'favorites' ? 'favorites' : 'All',
                    sapPartnerId: physicianSapPartnerId,
                });
            }
        }
    };
    // eslint-disable-next-line no-unused-vars
    const getAccountList = (data, districtIdFromEdit, territoryIdFromEdit) => {
        const { searchValue } = data;
        let params = {
            district: countryISOCode === US_COUNTRY_CODE ? selectedDistrict || '' : selectedDistrict,
            territory: countryISOCode === US_COUNTRY_CODE ? selectedTerritory || '' : selectedTerritory,
            searchParam: searchValue ? searchValue : '',
            isReplenishmentPage: true,
        };
        dispatch(getDropdownOptionsRequest('accounts', params));
    };

    const getBillToDetailsList = (data) => {
        const { searchValue = '' } = data;
        let params = {
            district: usageDetails.districtId
                ? usageDetails.districtId
                :  selectedDistrict ? selectedDistrict
                    : 'ALL_Districts',
            territory: usageDetails.territoryId
                ? usageDetails.territoryId
                : selectedTerritory ? selectedTerritory
                    : 'All_Territories',
            sapPartnerId: surgeryDetails.accountId.accountId,
            searchValue,
        };
        dispatch(getDropdownOptionsRequest('billToDetails', params));
    };

    const handleRequestDeliveryDate = (
        selectedDate,
        DatePicker = false,
        currentDateDelivery,
        isFromOutSide
    ) => {
        if (selectedDate && DatePicker) {
            const selectedRequestDeliveryDate = moment(selectedDate).toDate();

            if (selectedRequestDeliveryDate) {
                isFromOutSide && setIsFromOutSide(true);

                setRequestDeliveryDate(selectedDate);
            } else {
                setRequestDeliveryDate('');
            }
        } else {
            if (
                requestedDeliveryDateVisibility === VISIBLE &&
                requestDeliveryDate
            ) {
                dispatch(resetRepleneShippingMethods());
                setShippingMethodValue('');
            }

            setRequestDeliveryDate('');
            dispatch(storeRequestDeliveryDate(''));
            // handleInputChange('surgeryRequestDeliveryDateTime', '');
            let shippingPayload =
            // countryISOCode === COUNTRY_CODE_JAPN
            //     ?
            {
                orderType: 'ZLC',
                shipToAcc: nonTissueAddress[0]?.shippingAddressId
                    ? nonTissueAddress[0].shippingAddressId
                    : null,
                salesOrg: nonTissueAddress[0]?.salesOrg,
                isOutside: false,
                surgeryDate: SurgeryDate ? getRddDate(SurgeryDate) : '',

                currentDate: getJapanCurrentDateTime(
                    surgeryDetails?.accountId?.timeZoneOffset,
                    surgeryDetails?.accountId?.accountTimeZone,
                    true
                ),
                requestedDeliveryDateMandatoryRule:
                    countryISOCode !== 'US'
                        ? requestedDeliveryDateMandatory === 'YES'
                            ? 'YES'
                            : 'NO'
                        : '',
                requestedDeliveryDateVisbility:
                    countryISOCode !== 'US'
                        ? requestedDeliveryDateVisibility === VISIBLE
                            ? 'YES'
                            : 'NO'
                        : '',
            };
            // : {
            //       orderType: 'ZLC',
            //       shipToAcc: nonTissueAddress[0]?.shippingAddressId
            //           ? nonTissueAddress[0].shippingAddressId
            //           : null,
            //       salesOrg: nonTissueAddress[0]?.salesOrg,
            //       isOutside: false,
            //   };

            dispatch(getShippingMethods(shippingPayload));
        }
    };
    const handleInputChanges = (ev, value, isClear, name) => {
        if(ev)
        { ev.preventDefault();}
        const object = {
            [name]: value,
        };
        if (name == 'accountId') {
            setBillToFieldFlag(false);
            setSelectedAccount(value ? value?.accountFormattedName : '');
            setInsideAccountDetails(value ? value : null);
            if (value?.accountId) {
                if (countryISOCode === US_COUNTRY_CODE) {
                    dispatch(clearInsideShippingAddressWhenBillToCleared());
                    hasRestoredShipToRef.current = false;
                    initialSelectedShipToRef.current = null;
                    setInitialLoad(true);
                    setShippingMethodInitial(true);
                    setSelectedCard('');
                    setSelectedShipTo('');
                    setshipToInputValue(null);
                    setShippingMethodValue('');
                } else {
                    setSelectedBillTo('');
                    setSelectedBillToId(undefined);
                    setBillToInitialState(true);
                    dispatch(setUsageSurgeryInsideAction({ billToId: undefined }));
                    dispatch(clearInsideShippingAddressWhenBillToCleared());
                    hasRestoredShipToRef.current = false;
                    initialSelectedShipToRef.current = null;
                    setInitialLoad(true);
                    setShippingMethodInitial(true);
                    setSelectedCard('');
                    setSelectedShipTo('');
                    setshipToInputValue(null);
                    setShippingMethodValue('');
                }
            }
            if (billToReportUsageVisibility == 'VISIBLE' &&  value?.accountId) {
                const data = {
                    district: usageDetails.districtId
                        ? usageDetails.districtId
                        : selectedDistrict ? selectedDistrict
                            : 'ALL_Districts',
                    territory: usageDetails.territoryId
                        ? usageDetails.territoryId
                        : selectedTerritory ? selectedTerritory
                            : 'All_Territories',
                    sapPartnerId: value?.accountId,
                };
                dispatch(getDropdownOptionsRequest('billToDetails', data));
            }
        }

        if (name == 'billToId') {
            setSelectedBillTo(value ? value?.billToFormattedName : '');
            setSelectedBillToId(value);
            const data = {
                district: usageDetails.districtId
                    ? usageDetails.districtId
                    : selectedDistrict ? selectedDistrict
                        : 'ALL_Districts',
                territory: usageDetails.territoryId
                    ? usageDetails.territoryId
                    : selectedTerritory ? selectedTerritory
                        : 'All_Territories',
                sapPartnerId: surgeryDetails.accountId.accountId,
            };
            dispatch(getDropdownOptionsRequest('billToDetails', data));
        }

        if (
            !value ||
            (insideAccountDetails &&
                value?.accountId &&
                insideAccountDetails?.accountId &&
                insideAccountDetails.accountId !== value.accountId)
        ) {
            // setSelectedCard('');
            // setSelectedShipTo('');
            setAttnValue('');
            setCareOfValue('');
        }

        if (isClear !== 'clear' && isClear !== 'reset' && value) {
            dispatch(setUsageSurgeryInsideAction(object));
        } else if (name == 'accountId' && (value == null || value == '')) {
            if (countryISOCode === US_COUNTRY_CODE) {
                dispatch(clearInsideShippingAddress());
                hasRestoredShipToRef.current = false;
                initialSelectedShipToRef.current = null;
                setSelectedCard('');
                setSelectedShipTo('');
                setshipToInputValue(null);
                setShippingMethodValue('');
                setAttnValue('');
                setCareOfValue('');
            }
            setPhysicianValue('');
            setDefaultPhysicianValue('');
            dispatch(setUsageSurgeryInsideAction({ physicianId: '' }));
            setInitialFavoritesRequested(false);
            hasAppliedInitialFavoriteSelectionRef.current = false;
            shouldEvaluateInitialFavoritesFallbackRef.current = false;
            dispatch(clearSingleDropDownList({ name: 'physicians' }));
        } else if (name == 'billToId' && (value == null || value == '')) {
            dispatch(setUsageSurgeryInsideAction(object));
            dispatch(clearInsideShippingAddressWhenBillToCleared());
        }
    };

    const handleOnfocus = (event, field) => {
        if (field == 'accounts' && selectedAccount !== '') {
            getAccountList({
                searchValue:
                    selectedAccount || event?.target?.value?.trim() || '',
            });
        } else if (field == 'billToId') {
            getBillToDetailsList({
                searchValue: '',
            });
        } else {
            getAccountList({
                searchValue: '',
            });
        }
    };

    const handleSearch = (e, value, reason, fieldname) => {
        if (e?.type && (e.type === 'change' || e.type === 'click')) {
            if (reason !== 'reset') {
                let option = {
                    searchValue: value?.trim() || '',
                };
                if (fieldname == 'account') {
                    setSelectedAccount(value);
                    debouncedGetList(getAccountList, option);
                    setDisableFieldsBillTo(false);
                    setBillToFieldFlag(true);
                }
                if (fieldname == 'billToId') {
                    setSelectedBillTo(value);
                    debouncedGetList(getBillToDetailsList, option);
                }
                if (fieldname == 'account' && value == '') {
                    dispatch(clearInsideShippingAddress());
                    setAttnValue('');
                    setCareOfValue('');
                    setSelectedBillTo('');
                    setSelectedBillToId('');
                    setPhysicianValue('');
                    setDefaultPhysicianValue('');
                    dispatch(setUsageSurgeryInsideAction({ physicianId: '' }));
                    setInitialFavoritesRequested(false);
                    hasAppliedInitialFavoriteSelectionRef.current = false;
                    shouldEvaluateInitialFavoritesFallbackRef.current = false;
                    dispatch(clearSingleDropDownList({ name: 'physicians' }));
                }
                if (fieldname == 'billToId' && value == '') {
                    setSelectedBillTo('');
                    setSelectedBillToId('');
                    dispatch(clearInsideShippingAddressWhenBillToCleared());
                    const object = {
                        [fieldname]: value,
                    };
                    dispatch(setUsageSurgeryInsideAction(object));
                }
            } else {
                if (fieldname == 'account') {
                    setSelectedBillTo('');
                    setSelectedBillToId('');
                    setDisableFieldsBillTo(false);
                }
                if (fieldname == 'account' && value == '') {
                    dispatch(clearInsideShippingAddress());
                    setAttnValue('');
                    setCareOfValue('');
                    setSelectedBillTo('');
                    setPhysicianValue('');
                    setDefaultPhysicianValue('');
                    dispatch(setUsageSurgeryInsideAction({ physicianId: '' }));
                    setInitialFavoritesRequested(false);
                    hasAppliedInitialFavoriteSelectionRef.current = false;
                    shouldEvaluateInitialFavoritesFallbackRef.current = false;
                    dispatch(clearSingleDropDownList({ name: 'physicians' }));
                }
                if (fieldname == 'billToId' && value == '') {
                    setSelectedBillTo('');
                    dispatch(clearInsideShippingAddressWhenBillToCleared());
                }
            }
        }
    };

    const AccountTemplate = (option, fieldname, physiciantype, inputValue) => {
        return (
            <AccountPhysicianTemplate
                option={option}
                data={
                    fieldname == 'account'
                        ? accounts
                        : fieldname === 'transferRecipient'
                            ? transferRecipient
                            : []
                }
                optionValue={
                    fieldname == 'account'
                        ? 'accountId'
                        : fieldname === 'transferRecipient'
                            ? 'transferRecipient'
                            : 'physicianId'
                }
                fieldname={fieldname}
                physiciantype={physiciantype}
                physicianInputValue={inputValue}
            />
        );
    };

    const OptionBillTo = (option) => {
        return (
            <>
                <OptionContainer>
                    <div
                        style={{
                            width: '85%',
                            cursor: 'pointer',
                        }}
                    >
                        <label
                            className="template"
                            style={{ cursor: 'pointer' }}
                        >
                            <span className="report-usage-bill-to-option-dt-mask">{option.billToFormattedName}</span>
                        </label>
                    </div>

                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            justifyContent: 'flex-end',
                            alignItems: 'center',
                            height: '100%',
                            width: '15%',
                        }}
                    >
                        <ImageContainer
                            id={`reportUsage-selectShipToAddressDesktop-selectShipToAddress-billTo-image-${option.billToNumber}`}
                            onClick={(e) => {
                                e.stopPropagation();
                                getBillToDetailsList({
                                    // type: 'All',
                                    searchValue: '',
                                    loadAll: true,
                                    accountId: accountId,
                                });
                                // {billToValue}
                                // setBillToValue(option?.billToFormattedName);
                                closekeyBoard();
                            }}
                        ></ImageContainer>
                    </div>
                </OptionContainer>
            </>
        );
    };

    const handleShippingToCardClick = (item, index) => {
        if (item?.shippingAddressId) {
            let shippingPayload =
            // countryISOCode === COUNTRY_CODE_JAPN
            // ?
            {
                orderType: 'ZLC',
                shipToAcc: item.shippingAddressId,
                salesOrg: item.salesOrg,
                isOutside: false,
                surgeryDate: SurgeryDate ? getRddDate(SurgeryDate) : '',
                requestDeliveryDate:
                    countryISOCode !== 'US'
                        ? RequestDeliveryDate
                            ? getRddDate(RequestDeliveryDate)
                            : ''
                        : '',
                currentDate: getJapanCurrentDateTime(
                    surgeryDetails?.accountId?.timeZoneOffset,
                    surgeryDetails?.accountId?.accountTimeZone,
                    true
                ),
                requestedDeliveryDateMandatoryRule:
                    countryISOCode !== 'US'
                        ? requestedDeliveryDateMandatory === 'YES'
                            ? 'YES'
                            : 'NO'
                        : '',
                requestedDeliveryDateVisbility:
                    countryISOCode !== 'US'
                        ? requestedDeliveryDateVisibility === VISIBLE
                            ? 'YES'
                            : 'NO'
                        : '',
            };
            // : {
            //       orderType: 'ZLC',
            //       shipToAcc: item.shippingAddressId,
            //       salesOrg: item.salesOrg,
            //       isOutside: false,
            //   };
            if(requestedDeliveryDateMandatory === MANDATORY) {
                if(shippingPayload.requestDeliveryDate) dispatch(getShippingMethods(shippingPayload));
            } else {
                dispatch(getShippingMethods(shippingPayload));
            }
            setSelectedShipTo(item);
            setSelectedCard(index);
            setShippingMethodValue('');
            if (hasRestoredShipToRef.current) {
                initialShippingMethodRef.current = null;
            }
        }
    };

    useEffectWithErrorLogging(() => {
        shipToAddressOutsideRef.current?.scrollTo(0, 0);
    }, [advanceSearchValue]);

    useEffectWithErrorLogging(() => {
        if (
            selectedShipTo !== ''&&selectedShipTo !==undefined &&
            (isCondensedView
                ? shipToInputValue?.formattedShippingAddressId !== ''
                : true) &&
            (countryISOCode === COUNTRY_CODE_JAPN
                ? !showShippingMethod
                    ?shippingMethodValue&& Object.keys(shippingMethodValue).length > 1 &&
                    shippingMethodValue != ''
                    : false
                : shippingMethodValue != ''&&shippingMethodValue!== undefined) &&
            surgeryDetails?.accountId !== undefined &&
            surgeryDetails.accountId !== '' &&
            (physicianDropdownZGReportUsageReplenishmentVisibility !=
                'VISIBLE' ||
                physicianDropdownZGReportUsageReplenishmentMandatory !==
                'YES' ||
                (surgeryDetails?.physicianId !== undefined &&
                    surgeryDetails.physicianId !== '')) &&
            (countryISOCode !== US_COUNTRY_CODE ? selectedTerritory : (!showDistrictAsterisk || selectedTerritory)) &&
            ((requestedDeliveryDateMandatory !== 'YES' &&
                requestedDeliveryDateMandatory !== 'Yes') ||
                isRequestDeliveryMandate) &&
            ((usageReplenishmentSurgeryDateMandatoryRule !== 'YES' &&
                usageReplenishmentSurgeryDateMandatoryRule !== 'Yes') ||
                isSurgeryDateMandate) &&
            selectedAccount !== '' &&
            (countryISOCode !== US_COUNTRY_CODE ? (selectedDistrict || districts[0]?.districtName) : (!showDistrictAsterisk || (selectedDistrict || districts[0]?.districtName))) &&
            isSurgeryNumberMandate &&
            ((careOfFieldMandatory == MANDATORY && careOfValue !== '') ||
                careOfFieldMandatory !== MANDATORY) &&
            ((transferRecipientMandatory == MANDATORY && usageTransferRecipient?.addressId !== undefined) ||
                transferRecipientMandatory !== MANDATORY || !transferRecipientMeta.includes(shippingMethodValue?.shippingMethodId)) &&
            !attnErrorMsg &&
           (surgeryNumberUsageReplenishmentMandatory !== 'YES' || numberOfSurgery !== undefined)
        ) {
            setEnableAddressButton(true);
        } else {
            setEnableAddressButton(false);
        }
        transferRecipientMeta.includes(shippingMethodValue?.shippingMethodId) && getTransferRecipientList('');
    }, [
        selectedShipTo,
        shippingMethodValue,
        surgeryDetails?.accountId,
        selectedTerritory,
        selectedDistrict,
        districts,
        requestDeliveryDate,
        surgeryDate,
        isSurgeryDateMandate,
        careOfValue,
        usageTransferRecipient,
        physicianInputValue,
        attnErrorMsg,
        numberOfSurgery
    ]);

    const advanceSearch = () => {
        setAdvanceSearchValue(!advanceSearchValue);
    };

    const selectedItems = gridData.filter(
        (x) => x.isSelected && !x.accountOwned
    );
    const handleOnClose = () => {
        setFormValues({
            terrirotryCode: '',
        });
        dispatch(
            clearSingleDropDownList({
                name: 'districts',
            })
        );
        // dispatch(
        //     clearSingleDropDownList({
        //         name: 'territories',
        //     })
        // );
        dispatch(getDropdownOptionsRequest('districts'));
        const territoryPayloadObj = {
            districtCode:
                districtAndTerritory?.district &&
                (districtAndTerritory.district === AllDistricts
                    ? ''
                    : districtAndTerritory.district),
            searchParam: '',
            isReplenishmentPage: true,
        };
        dispatch(getDropdownOptionsRequest('territories', territoryPayloadObj));
        const payloadObj = {
            district: districtAndTerritory?.district,
            territory: districtAndTerritory?.territory,
            searchParam: '',
            isReplenishmentPage: true,
        };
        dispatch(getDropdownOptionsRequest('accounts', payloadObj));
        dispatch(setSelectedOutsideAccount(''));
        onClose(false);
        setAttnValue('');
        setCareOfValue('');
        setSelectedShipTo('');
        setShippingMethodValue('');
        dispatch(setReplenishmentSurgeryNumber(''));
        dispatch(resetRepleneShippingMethods());
    };

    useEffectWithErrorLogging(() => {
        if (
            territories?.length === 1 &&
            selectedDistrict &&
            selectedDistrict !== ''
        ) {
            setSelectedTerritory(territories[0].terrirotryCode);
        }
    }, [territories, selectedDistrict]);

    // useEffectWithErrorLogging(() => {
    //     if (
    //         territories?.length === 1 &&
    //         selectedDistrict &&
    //         selectedDistrict !== '' &&
    //         nonTissueAddress?.length > 0 &&
    //         shiptoAccountId
    //     ) {
    //         const selectedShipToAdd = nonTissueAddress.find(
    //             (item) => item?.shippingAddressId === shiptoAccountId
    //         );

    //         selectedShipToAdd &&
    //             setShipToAddresstValue(
    //                 selectedShipToAdd?.formattedShippingAddressId
    //             );
    //     }
    // }, [territories, selectedDistrict, nonTissueAddress, selectedAccount]);
    const OptionTransferRecipient = (option) => {
        return (
            <>
                <OptionContainer>
                    <div
                        style={{
                            width: '85%',
                            cursor: 'pointer',
                        }}
                    >
                        <label
                            className="template"
                            style={{ cursor: 'pointer' }}
                        >
                            <span className="report-usage-account-dt-mask">{option.accountName}</span>
                        </label>
                    </div>
                </OptionContainer>
            </>
        );
    };

    const ShipToOptionTemplate = (option, fieldname) => {
        return <ShipToTemplate option={option} fieldname={'shipTo'} />;
    };

    const getTransferRecipientList = (data) => {
        const { searchAccountParam = '' } = data;
        let params = {
            sapPartnerId: insideAccountDetails?.accountId,
            shippingMethodSelected: shippingMethodValue?.shippingMethodId,
            searchAccountParam,
        };
        dispatch(getTransferRecipientMethods(params));
    };

    const getShipToAddressList = (value) => {
        dispatch(getShipToAddress({ isInside: true, searchValue: value }));
    };

    const handleTransferRecipient = (field, event, value, reason) => {
        if (field == 'handleSearch') {
            if (reason !== 'reset') {
                let option = {
                    searchAccountParam: value?.trim() || '',
                };
                setTransferRecipientValue(value);
                setTransferRecipientSelectedValue(value);
                debouncedGetList(getTransferRecipientList, option);
            } else {
                setTransferRecipientValue(value);
                setTransferRecipientSelectedValue(value);
            }
        }
        if (field == 'handleInputChange') {
            setUsageTransferRecipient(value);
            setTransferRecipientValue(value);
        }
        if (field == 'handleOnFocus') {
            // const params = {
            //     sapPartnerId: insideAccountDetails?.accountId,
            // };
            // dispatch(getTransferRecipientMethods(params));
            let params = '';
            getTransferRecipientList(params);
            setOpenTransferRecipientDropdown(true);
        }

        if (field == 'handleDisableField') {
            setOpenTransferRecipientDropdown(value);
        }
    };
    const handleShipToAddress = (field, event, value, reason) => {
        if (field == 'handleSearch' && value !== undefined) {
            if (reason === 'reset' || reason === 'clear') {
                setshipToInputValue({ searchValue: value });
            } else {
                const searchAccountParam = value?.trim() || '';
                setshipToInputValue({ searchValue: searchAccountParam });
                debouncedGetList(getShipToAddressList, searchAccountParam);
            }
        }
        if (field == 'handleInputChange') {
            if (!value) {
                hasRestoredShipToRef.current = true;
                setSelectedShipTo('');
                setshipToInputValue(emptyAddressObj);
                if (reason !== 'reset') {
                    setShippingMethodValue('');
                    initialShippingMethodRef.current = null;
                    setTransferRecipientValue('');
                    setUsageTransferRecipient('');
                    setTransferRecipientSelectedValue('');
                    dispatch(resetRepleneShippingMethods());
                }
            } else {
                setshipToInputValue(value);
                handleShippingToCardClick(value, value?.accountId);
                setSelectedShipTo(value);
            }
        }

        if (field == 'handleOnFocus') {
            getShipToAddressList('');
            setOpenShipToAddressDropdown(true);
        }

        if (field == 'handleDisableField') {
            setOpenShipToAddressDropdown(value);
        }
    };
    const renderNoOption = (
        <OptionalLoadMoreView
            height={physiciantype == 'All' ? '200px' : '158px'}
        >
            {physiciantype == 'All' ? (
                <>
                    <p
                        style={{
                            fontSize: '12px',
                            marginBottom: '5px',
                        }}
                    >
                        {t('scheduleSurgery.details.notRecetPhysicianMSG')}
                        <br></br>
                        {t(
                            'scheduleSurgery.details.trySearchingByTypeMSG'
                        )}{' '}
                    </p>
                    <p>
                        {t('scheduleSurgery.details.cantFindWhoYou')}
                        <br></br>
                        {t('scheduleSurgery.details.areLookingFor')}{' '}
                    </p>
                    <button
                        onMouseDown={() => {
                            try {
                                handleLoadAll(true);
                            } catch (error) {
                                logErrorToConsole(error);
                            }

                        }}
                    >
                        {t('scheduleSurgery.details.loadAllPhysicians')}
                    </button>
                </>
            ) : (
                <>
                    <p
                        style={{
                            marginBottom: '7px',
                        }}
                    >
                        {t('scheduleSurgery.details.noFavoritePhysuciansSet')}
                    </p>
                    <button
                        style={{ width: '236px', fontSize: '15px' }}
                        onMouseDown={() => {
                            try {
                                physicianTypeChange(
                                    physiciantype === 'All' ? 'favorites' : 'All',
                                    true
                                );
                            } catch (error) {
                                logErrorToConsole(error);
                            }
                        }}
                    >
                        {t(
                            'scheduleSurgery.details.switchToTerritoryPhysicians'
                        )}
                    </button>
                </>
            )}
        </OptionalLoadMoreView>
    );
    return (
        <>
            <ModalDialog
                modalHeight={isIpad() ? '50vh' : '75vh'}
                maxWidth={'841px'}
                marginTop={isMobileView() ? '7.75rem' : '14rem'}
                padding="0px"
                zIndex={2000}
                handleClose={()=>handleOnClose()}
            >
                <>
                    <SelectShipToAddressContainer
                        isIpad={isIpad()}
                        mbHeight={'85vh'}
                        ref={shipToAddressOutsideRef}
                        scrollBarWidth={'8px'}
                        scrollBarBackgroundColor={'#888'}
                        scrollBarBorderRadius={'10px'}
                    >
                        <HeaderDiv>
                            <HeaderTitle mbMarginLeft={'6px'}>
                                {advanceSearchValue
                                    ? t(
                                        'consignmentBilling.replen.selectShipToAddress.advanceAccountSearch'
                                    )
                                    : t(
                                        'consignmentBilling.replen.selectShipToAddress.replenishShipTo'
                                    )}
                            </HeaderTitle>
                            {/* <Icon 
                            id="select-ship-to-address-popup-close-icon"
                            path={Close} onClick={handleOnClose} /> */}
                        </HeaderDiv>

                        {advanceSearchValue ? (
                            <>
                                <AdvanceAccountSearch
                                    handleTerritoryValue={advanceSearch}
                                    onClose={onClose}
                                    advanceSearchValue={advanceSearchValue}
                                    setAdvanceSearchValue={
                                        setAdvanceSearchValue
                                    }
                                    selectedList={selectedList}
                                    setSelectedList={setSelectedList}
                                />
                            </>
                        ) : (
                            <>
                                <div>
                                    <p style={{ wordWrap: 'break-word' }}>
                                        <HeadingShipAddress>
                                            {`${t(
                                                'consignmentBilling.replen.selectShipToAddress.for'
                                            )}  ${selectedItems?.length}  ${
                                                selectedItems?.length === 1
                                                    ? t(
                                                        'equity.common.templateDetails.item'
                                                    )
                                                    : t('equity.cart.items')
                                                }:`}
                                        </HeadingShipAddress>
                                        {selectedItems
                                            .map((x) => x.cfn)
                                            .toString()}
                                    </p>
                                </div>
                                <MainContainer
                                    mobileMargin={
                                        isCondensedView &&
                                        '10px -15px 2px -15px'
                                    }
                                >
                                    <Title>
                                        {t(
                                            'reportUsage.replen.selectShipToAddress.shippingLabel'
                                        )}
                                    </Title>
                                    <RadioRowDiv width="108%">
                                        <RadioButton
                                            isChecked={
                                                territory == WithinTerritory()
                                                    ? true
                                                    : false
                                            }
                                            id={'shipping-label-within'}
                                            label={WithinTerritory()}
                                            value={WithinTerritory()}
                                            fontFamilyStyle="AvenirNextWorld Regular"
                                            handleChange={(value) =>
                                                handleInputChange('All', value)
                                            }
                                            name="territory"
                                        />
                                        <RadioButton
                                            isChecked={
                                                territory == OutsideTerritory()
                                                    ? true
                                                    : false
                                            }
                                            id={'shipping-label-outside'}
                                            label={OutsideTerritory()}
                                            handleChange={(value) =>
                                                handleInputChange('All', value)
                                            }
                                            value={OutsideTerritory()}
                                            fontFamilyStyle="AvenirNextWorld Regular"
                                            name="territory"
                                        />
                                    </RadioRowDiv>
                                </MainContainer>
                                {territory == OutsideTerritory() ? (
                                    <SelectShipToAddressOutside
                                        accountId={accountId}
                                        advanceSearch={advanceSearch}
                                        advanceSearchValue={advanceSearchValue}
                                        selectedList={selectedList}
                                        onClose={onClose}
                                        gridData={gridData}
                                        setGridData={setGridData}
                                        accounts={accounts}
                                        districts={districts}
                                        territories={territories}
                                        territory={territory}
                                        setSelectedList={setSelectedList}
                                        requestedDeliveryDateVisibility={
                                            requestedDeliveryDateVisibility
                                        }
                                        nextDay={nextDay}
                                        getDisable={getDisable}
                                        countryISOCode={countryISOCode}
                                        requestedDeliveryDateMandatory={
                                            requestedDeliveryDateMandatory
                                        }
                                        handleRequestDeliveryDate={
                                            handleRequestDeliveryDate
                                        }
                                        handleSurgeryDate={handleSurgeryDate}
                                        requestDeliveryDate={
                                            requestDeliveryDate
                                        }
                                        isRequestDeliveryMandate={
                                            isRequestDeliveryMandate
                                        }
                                        usageReplenishmentSurgeryDateMandatoryRule={
                                            usageReplenishmentSurgeryDateMandatoryRule
                                        }
                                        isSurgeryDateMandate={
                                            isSurgeryDateMandate
                                        }
                                        shippingMethodValue={
                                            shippingMethodValue
                                        }
                                        setShippingMethodValue={
                                            setShippingMethodValue
                                        }
                                        replenishmentSurgeryNumber={
                                            replenishmentSurgeryNumber
                                        }
                                        numberOfSurgery={numberOfSurgery}
                                        setNumberOfSurgery={setNumberOfSurgery}
                                        surgeryNumberUsageReplenishmentMandatory={
                                            surgeryNumberUsageReplenishmentMandatory
                                        }
                                        surgeryNumberUsageReplenishmentVisibility={
                                            surgeryNumberUsageReplenishmentVisibility
                                        }
                                        usageReplenishmentSurgeryDateVisibility={
                                            usageReplenishmentSurgeryDateVisibility
                                        }
                                        surgeryDate={surgeryDate}
                                        setSurgeryDate={setSurgeryDate}
                                        setAccountData={setAccountData}
                                        accountData={accountData}
                                        applyClickOutside={applyClickOutside}
                                        setApplyClickOutside={
                                            setApplyClickOutside
                                        }
                                        shipToClick={shipToClick}
                                        setShipToClick={setShipToClick}
                                        applyShippingAddress={
                                            applyShippingAddress
                                        }
                                        AccountId={surgeryDetails?.accountId}
                                        setUsageTransferRecipient={
                                            setUsageTransferRecipient
                                        }
                                        usageTransferRecipient={
                                            usageTransferRecipient
                                        }
                                        setSelectedShipTo={setSelectedShipTo}
                                        selectedShipTo={selectedShipTo}
                                        setCareOfValue={setCareOfValue}
                                        careOfValue={careOfValue}
                                        isSurgeryNumberMandate={
                                            isSurgeryNumberMandate
                                        }
                                        setAttnValue={setAttnValue}
                                        attnValue={attnValue}
                                    />
                                ) : (
                                    <>
                                        <CollapsableCard id="reportUsage-selectShipToAddressDesktop-selectShipToAddress-dTerritoryTitle"
                                            mobileMargin={
                                                isCondensedView &&
                                                '10px -15px 2px -15px'
                                            }
                                            title={t('equity.dTerritory.title')}
                                            onClick={() =>
                                                toggleCard(
                                                    'district',
                                                    !expandedCard.district
                                                )
                                            }
                                            isExpanded={expandedCard.district}
                                            padding={
                                                isMobileView() ? '22px' : '15px'
                                            }
                                        >
                                            {expandedCard.district && (
                                                <>
                                                    <DistrictContainer>
                                                        <MainContainerItems
                                                            setMarginBottom={
                                                                true
                                                            }
                                                        >
                                                            <Title
                                                                fontSize={
                                                                    '14px'
                                                                }
                                                                color={
                                                                    '#202124'
                                                                }
                                                                showAstrisk={
                                                                    showDistrictAsterisk
                                                                }
                                                            >
                                                                {t(
                                                                    'consignmentBilling.replen.selectShipToAddress.district'
                                                                )}
                                                            </Title>
                                                            {districts?.length >
                                                                1 ? (
                                                                <>
                                                                    <Select
                                                                        id="reportUsage-selectShipToAddressDesktop-selectShipToAddress-districtName"
                                                                        value={
                                                                            selectedDistrict
                                                                        }
                                                                        options={
                                                                            districts
                                                                        }
                                                                        onChange={
                                                                            onDistrictChange
                                                                        }
                                                                        placeholder={t(
                                                                            'equity.dTerritory.district.placeholder'
                                                                        )}
                                                                        optionValue="districtCode"
                                                                        optionLabel="districtName"
                                                                        name="districtId"
                                                                        itemTemplate={(
                                                                            option
                                                                        ) => {
                                                                            if (
                                                                                option
                                                                            ) {
                                                                                return (
                                                                                    <SelectTemplate
                                                                                        width={
                                                                                            window.innerWidth <=
                                                                                                sizes.mobileDevice
                                                                                                ? '240px'
                                                                                                : '100%'
                                                                                        }
                                                                                        whiteSpace={
                                                                                            'pre-wrap'
                                                                                        }
                                                                                    >
                                                                                        {
                                                                                            option.districtName
                                                                                        }
                                                                                    </SelectTemplate>
                                                                                );
                                                                            }
                                                                        }}
                                                                        disabled={
                                                                            districts?.length <=
                                                                            1
                                                                        }
                                                                    />
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <Subtitle>
                                                                        {districts?.length >=
                                                                            1
                                                                            ? districts[0]
                                                                                .districtName
                                                                            : ''}
                                                                    </Subtitle>
                                                                </>
                                                            )}
                                                        </MainContainerItems>
                                                        <MainContainerItems
                                                            setMarginBottom={
                                                                true
                                                            }
                                                        >
                                                            <Title
                                                                fontSize={
                                                                    '14px'
                                                                }
                                                                color={
                                                                    '#202124'
                                                                }
                                                                showAstrisk={
                                                                    showDistrictAsterisk
                                                                }
                                                            >
                                                                {t(
                                                                    'consignmentBilling.replen.selectShipToAddress.territory'
                                                                )}
                                                            </Title>
                                                            {(territories &&
                                                                territories?.length >
                                                                1) ||
                                                                districts?.length >
                                                                1 ? (
                                                                <>
                                                                    <Select
                                                                        id="reportUsage-selectShipToAddressDesktop-selectShipToAddress-territoryName"
                                                                        value={
                                                                            selectedTerritory
                                                                        }
                                                                        options={
                                                                            territories
                                                                        }
                                                                        onChange={
                                                                            onTerritoryChange
                                                                        }
                                                                        placeholder={t(
                                                                            'equity.dTerritory.territory.placeholder'
                                                                        )}
                                                                        optionValue="terrirotryCode"
                                                                        optionLabel="terrirotryName"
                                                                        name="terrirotryCode"
                                                                        disabled={
                                                                            (!selectedDistrict &&
                                                                                districts?.length !==
                                                                                1) ||
                                                                            territories?.length <=
                                                                            1
                                                                        }
                                                                        mbMarginRight='35px'
                                                                    />
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <Subtitle>
                                                                        {territories?.length >=
                                                                            1
                                                                            ? territories[0]
                                                                                .terrirotryName
                                                                            : ''}
                                                                    </Subtitle>
                                                                </>
                                                            )}
                                                        </MainContainerItems>
                                                    </DistrictContainer>
                                                </>
                                            )}
                                        </CollapsableCard>
                                        <div>
                                            <MainContainerThird
                                                mobileMargin={
                                                    isCondensedView &&
                                                    '10px -15px 2px -15px'
                                                }
                                                mobileWidth={
                                                    isCondensedView && 'auto'
                                                }
                                            >
                                                {/* {billToReportUsageVisibility ==
                                                    'VISIBLE' && (
                                                    <MainContainerSecond> */}
                                                <FlexDiv>
                                                    <MainContainerSecond marginBottom="16px">
                                                        <Title
                                                            showAstrisk={true}
                                                        >
                                                            {t(
                                                                'consignmentBilling.replen.selectShipToAddress.account'
                                                            )}
                                                        </Title>
                                                        <AutoComplete
                                                            inputRef={
                                                                accountRef
                                                            }
                                                            showScrollBar={true}
                                                            disableClearable={
                                                                false
                                                            }
                                                            isFullWidth={true}
                                                            customWidth={
                                                                billToReportUsageVisibility !==
                                                                    'VISIBLE'
                                                                    ? '46%'
                                                                    : '98%'
                                                            }
                                                            boxShadow={
                                                                '0px 3px 6px #00000029'
                                                            }
                                                            options={
                                                                accounts &&
                                                                    accounts?.length >
                                                                    0
                                                                    ? accounts
                                                                    : []
                                                            }
                                                            value={
                                                                countryISOCode !== US_COUNTRY_CODE
                                                                    ? (!selectedTerritory ||
                                                                        (!selectedDistrict &&
                                                                            !districts[0]
                                                                                ?.districtName)
                                                                        ? ''
                                                                        : insideAccountDetails
                                                                            ? insideAccountDetails
                                                                            : '')
                                                                    : insideAccountDetails
                                                                        ? insideAccountDetails
                                                                        : ''
                                                            }
                                                            inputValue={
                                                                countryISOCode !== US_COUNTRY_CODE
                                                                    ? (!selectedTerritory ||
                                                                        (!selectedDistrict &&
                                                                            !districts[0]
                                                                                ?.districtName)
                                                                        ? ''
                                                                        : insideAccountDetails
                                                                            ? insideAccountDetails?.accountFormattedName
                                                                            : selectedAccount
                                                                                ? selectedAccount
                                                                                : '')
                                                                    : insideAccountDetails
                                                                        ? insideAccountDetails?.accountFormattedName
                                                                        : selectedAccount
                                                                            ? selectedAccount
                                                                            : ''
                                                            }
                                                            itemTemplate={(
                                                                option
                                                            ) =>
                                                                AccountTemplate(
                                                                    option,
                                                                    'account'
                                                                )
                                                            }
                                                            hideNoOptionText={
                                                                false
                                                            }
                                                            noOptionsText={
                                                                !accountsOptionLoading &&
                                                                    accounts?.length ===
                                                                    0
                                                                    ? t(
                                                                        'calendar.filterResultsPanel.noOptionText'
                                                                    )
                                                                    : accountsOptionLoading &&
                                                                    t(
                                                                        'common.loadingText'
                                                                    )
                                                            }
                                                            placeholder={t(
                                                                'reportUsage.replen.selectShipToAddress.SelectShipToAddressOutside.selectAccount'
                                                            )}
                                                            field="accountFormattedName"
                                                            optionValue="accountFormattedName"
                                                            id="reportUsage-replen-shipping-shippingAddress"
                                                            loading={
                                                                accountsOptionLoading
                                                            }
                                                            onChange={(
                                                                value,
                                                                reason
                                                            ) => {
                                                                if (
                                                                    reason ===
                                                                    'clear'
                                                                ) {
                                                                    setSelectedAccount(
                                                                        ''
                                                                    );
                                                                    setInsideAccountDetails(
                                                                        null
                                                                    );
                                                                    setshipToInputValue(
                                                                        emptyAddressObj
                                                                    );
                                                                    handleSearch(
                                                                        '',
                                                                        '',
                                                                        true,
                                                                        'account'
                                                                    );
                                                                    setSelectedCard(
                                                                        ''
                                                                    );
                                                                    setPhysicianValue('');
                                                                    setInitialLoad(true);
                                                                }
                                                                handleInputChanges(
                                                                    '',
                                                                    value,
                                                                    reason,
                                                                    'accountId'
                                                                );
                                                                if (
                                                                    value === ''
                                                                )
                                                                    handleDisableField(
                                                                        'account',
                                                                        true
                                                                    );
                                                            }}
                                                            onInputChange={(
                                                                event,
                                                                value,
                                                                reset
                                                            ) => {
                                                                {
                                                                    if (value) {
                                                                        handleSearch(
                                                                            event,
                                                                            value,
                                                                            reset,
                                                                            'account'
                                                                        );
                                                                    } else if (
                                                                        reset ===
                                                                        'clear'
                                                                    ) {
                                                                        setSelectedAccount(
                                                                            ''
                                                                        );
                                                                        setInsideAccountDetails(
                                                                            null
                                                                        );
                                                                        handleSearch(
                                                                            '',
                                                                            '',
                                                                            true,
                                                                            'account'
                                                                        );
                                                                    }
                                                                }
                                                            }}
                                                            onFocus={(event) => {
                                                                if (event?.target?.value !== insideAccountDetails?.accountFormattedName) {
                                                                    handleOnfocus(
                                                                        event,
                                                                        'accounts'
                                                                    );
                                                                }
                                                            }}
                                                            disabled={
                                                                countryISOCode !== US_COUNTRY_CODE
                                                                    ? (!selectedTerritory ||
                                                                        (!selectedDistrict &&
                                                                            !districts[0]
                                                                                ?.districtName))
                                                                    : false
                                                            }
                                                            onOpen={() => {
                                                                try {
                                                                    if (countryISOCode !== US_COUNTRY_CODE) {
                                                                        if (
                                                                            !selectedTerritory ||
                                                                            (!selectedDistrict &&
                                                                                !districts[0]
                                                                                    ?.districtName)
                                                                        ) {
                                                                            handleDisableField(
                                                                                'account',
                                                                                false
                                                                            );
                                                                        } else {
                                                                            handleDisableField(
                                                                                'account',
                                                                                true
                                                                            );
                                                                        }
                                                                    } else {
                                                                        handleDisableField(
                                                                            'account',
                                                                            true
                                                                        );
                                                                    }
                                                                } catch (error) {
                                                                    logErrorToConsole(error);
                                                                }
                                                            }}
                                                            onClose={() => {
                                                                try {
                                                                    handleDisableField(
                                                                        'account',
                                                                        false
                                                                    );
                                                                } catch (error) {
                                                                    logErrorToConsole(error);
                                                                }
                                                            }}
                                                            open={
                                                                insideAccountDetails?.accountFormattedName
                                                                    ? false
                                                                    : disableFields.account
                                                            }
                                                            readOnly={
                                                                insideAccountDetails?.accountFormattedName
                                                            }
                                                            detailsMargin
                                                            marginLeft={'1.5px'}
                                                            clearOnBlur={false}
                                                            zIndex={'99999'}
                                                            ListboxProps={{
                                                                style: {
                                                                    maxHeight:
                                                                        'auto',
                                                                },
                                                            }}
                                                        />
                                                    </MainContainerSecond>
                                                    {billToReportUsageVisibility ==
                                                        'VISIBLE' && (
                                                            <MainContainerSecond
                                                                marginLeft={
                                                                    window.innerWidth >=
                                                                        sizes.smalDevice
                                                                        ? '50px'
                                                                        : ''
                                                                }
                                                                marginBottom="16px"
                                                            >
                                                                <Title
                                                                    showAstrisk={
                                                                        billToReportUsageMandatory ==
                                                                        'YES'
                                                                    }
                                                                >
                                                                    {t(
                                                                        'equity.billToDetails.details.detailsTitle'
                                                                    )}
                                                                </Title>

                                                                <AutoComplete
                                                                    inputRef={
                                                                        billToRef
                                                                    }
                                                                    showScrollBar={
                                                                        true
                                                                    }
                                                                    disableClearable={
                                                                        false
                                                                    }
                                                                    isFullWidth={
                                                                        true
                                                                    }
                                                                    boxShadow={
                                                                        '0px 3px 6px #00000029'
                                                                    }
                                                                    options={
                                                                        billToDetails &&
                                                                            billToDetails?.length >
                                                                            0
                                                                            ? billToDetails
                                                                            : []
                                                                    }
                                                                    value={
                                                                        selectedAccount ===
                                                                            ''
                                                                            ? ''
                                                                            : selectedBillTo
                                                                                ? selectedBillTo
                                                                                : ''
                                                                    }
                                                                    inputValue={
                                                                        selectedAccount ===
                                                                            ''
                                                                            ? ''
                                                                            : selectedBillTo?.billToFormattedName
                                                                                ? selectedBillTo?.billToFormattedName
                                                                                : selectedBillTo
                                                                                    ? selectedBillTo
                                                                                    : ''
                                                                    }
                                                                    clearOnBlur={
                                                                        false
                                                                    }
                                                                    itemTemplate={(
                                                                        option
                                                                    ) =>
                                                                        OptionBillTo(
                                                                            option
                                                                            //  'billToId'
                                                                        )
                                                                    }
                                                                    onChange={(
                                                                        value,
                                                                        reason
                                                                    ) => {
                                                                        if (
                                                                            reason ===
                                                                            'clear'
                                                                        ) {
                                                                            handleSearch(
                                                                                '',
                                                                                '',
                                                                                reason,
                                                                                'billToId'
                                                                            );
                                                                        }
                                                                        handleInputChanges(
                                                                            '',
                                                                            value
                                                                                ? value
                                                                                : '',
                                                                            reason,
                                                                            'billToId'
                                                                        );
                                                                        if (
                                                                            value ===
                                                                            ''
                                                                        )
                                                                            setDisableFieldsBillTo(
                                                                                true
                                                                            );
                                                                    }}
                                                                    hideNoOptionText={
                                                                        false
                                                                    }
                                                                    placeholder={t(
                                                                        'equity.billToDetails.details.placeholder'
                                                                    )}
                                                                    field="billToFormattedName"
                                                                    optionValue="billToFormattedName"
                                                                    id={
                                                                        'reportUsage-replen-selectShipTo-billTo'
                                                                    }
                                                                    onInputChange={(
                                                                        event,
                                                                        value,
                                                                        reset
                                                                    ) => {
                                                                        if (value) {
                                                                            handleSearch(
                                                                                event,
                                                                                value,
                                                                                reset,
                                                                                'billToId'
                                                                            );
                                                                        } else if (
                                                                            reset ===
                                                                            'clear'
                                                                        ) {
                                                                            handleSearch(
                                                                                '',
                                                                                '',
                                                                                reset,
                                                                                'billToId'
                                                                            );
                                                                        }
                                                                    }}
                                                                    loading={
                                                                        billToLoading
                                                                    }
                                                                    noOptionsText={
                                                                        !billToLoading &&
                                                                            billToDetails?.length ===
                                                                            0
                                                                            ? t(
                                                                                'calendar.filterResultsPanel.noOptionText'
                                                                            )
                                                                            : billToLoading &&
                                                                            t(
                                                                                'common.loadingText'
                                                                            )
                                                                    }
                                                                    onFocus={(
                                                                        event
                                                                ) => {()=>{
                                                                            if (event?.target?.value !== selectedBillTo?.billToFormattedName) {
                                                                                handleOnfocus(
                                                                                    event,
                                                                                    'accounts'
                                                                                );
                                                                            }
                                                                        };
                                                                    }}
                                                                    disabled={
                                                                        billToFieldFlag
                                                                    }
                                                                    onOpen={() => {
                                                                        try {
                                                                            if (
                                                                                selectedAccount ===
                                                                                ''
                                                                            ) {
                                                                                setDisableFieldsBillTo(
                                                                                    false
                                                                                );
                                                                            } else {
                                                                                setDisableFieldsBillTo(
                                                                                    true
                                                                                );
                                                                            }
                                                                        } catch (error) {
                                                                            logErrorToConsole(error);
                                                                        }
                                                                    }}
                                                                    onClose={() => {
                                                                        try {
                                                                            setDisableFieldsBillTo(
                                                                                false
                                                                            );
                                                                        } catch (error) {
                                                                            logErrorToConsole(error);
                                                                        }
                                                                    }}
                                                                    open={
                                                                        selectedBillTo?.billToFormattedName
                                                                            ? false
                                                                            : disableFieldsBillTo
                                                                    }
                                                                    readOnly={
                                                                        selectedBillTo
                                                                    }
                                                                    detailsMargin
                                                                    marginLeft={
                                                                        '1.5px'
                                                                    }
                                                                    zIndex={'99999'}
                                                                />
                                                            </MainContainerSecond>
                                                        )}
                                                </FlexDiv>
                                                {physicianDropdownZGReportUsageReplenishmentVisibility ===
                                                    'VISIBLE' ? (
                                                    <MainContainerSecond
                                                        setMarginBottom={true}
                                                        setMarginTop={
                                                            billToReportUsageVisibility ===
                                                                'VISIBLE' &&
                                                                window.innerWidth <=
                                                                sizes.mobileDevice
                                                                ? '0px'
                                                                : '20px'
                                                        }
                                                    >
                                                        <Title
                                                            showAstrisk={
                                                                physicianDropdownZGReportUsageReplenishmentMandatory ===
                                                                'YES'
                                                            }
                                                        >
                                                            {t(
                                                                'common.physicianLabel'
                                                            )}
                                                        </Title>
                                                        <RadioRowDiv marginBottom="15px">
                                                            <RadioButton
                                                                isChecked={
                                                                    physiciantype ==
                                                                        'favorites' ||
                                                                        !physiciantype
                                                                        ? true
                                                                        : false
                                                                }
                                                                id={
                                                                    'favoritesLabel'
                                                                }
                                                                label={t(
                                                                    'common.favoritesLabel'
                                                                )}
                                                                handleChange={() => {
                                                                    try {
                                                                        !disableFormFields &&
                                                                            physicianTypeChange(
                                                                                'favorites'
                                                                            );
                                                                        // physicianRef.current?.focus();
                                                                    } catch (error) {
                                                                        logErrorToConsole(error);
                                                                    }
                                                                }}
                                                                value={
                                                                    physiciantype
                                                                }
                                                                fontFamilyStyle="AvenirNextWorld Regular"
                                                                disabled={
                                                                    disableFormFields
                                                                }
                                                            />
                                                            <RadioButton
                                                                isChecked={
                                                                    physiciantype ==
                                                                        'All'
                                                                        ? true
                                                                        : false
                                                                }
                                                                id={
                                                                    'accountLabel'
                                                                }
                                                                label={
                                                                    salesOrg ===
                                                                        'S024' ||
                                                                        countryISOCode ===
                                                                        'JP'
                                                                        ? t(
                                                                            'common.hospital'
                                                                        )
                                                                        : t(
                                                                            'common.accountLabel'
                                                                        )
                                                                }
                                                                handleChange={() => {
                                                                    try {
                                                                        !disableFormFields &&
                                                                            physicianTypeChange(
                                                                                'All'
                                                                            );
                                                                        physicianRef.current?.focus();
                                                                    } catch (error) {
                                                                        logErrorToConsole(error);
                                                                    }
                                                                }}
                                                                value={
                                                                    physiciantype
                                                                }
                                                                fontFamilyStyle="AvenirNextWorld Regular"
                                                                disabled={
                                                                    disableFormFields
                                                                }
                                                            />
                                                        </RadioRowDiv>
                                                        <AutoCompleteContainer
                                                            width={
                                                                window.innerWidth ===
                                                                    sizes.smalDevice
                                                                    ? '91%'
                                                                    : '92%'
                                                            }
                                                            border="0px"
                                                        >
                                                            <AutoComplete
                                                                mbWidth="100%"
                                                                showScrollBar={
                                                                    true
                                                                }
                                                                disableClearable={
                                                                    false
                                                                }
                                                                width={
                                                                    window.innerWidth >=
                                                                        sizes.smalDevice &&
                                                                        window.innerWidth <
                                                                        sizes.ipadAir
                                                                        ? '100%'
                                                                        : '100%'
                                                                }
                                                                isPhysicianField={
                                                                    true
                                                                }
                                                                isFromShiptoAddress={
                                                                    false
                                                                }
                                                                isFromPhysician={
                                                                    true
                                                                }
                                                                inputRef={
                                                                    physicianRef
                                                                }
                                                                noOptionStyle={
                                                                    true
                                                                }
                                                                value={
                                                                    surgeryDetails?.physicianId ??
                                                                    ''
                                                                }
                                                                options={
                                                                    physicianDetails ||
                                                                    []
                                                                }
                                                                itemTemplate={(
                                                                    option
                                                                ) =>
                                                                    AccountTemplatee(
                                                                        option,
                                                                        'physician',
                                                                        physiciantype,
                                                                        physicianInputValue
                                                                    )
                                                                }
                                                                placeholder={t(
                                                                    'common.selectOrSearchPhusician'
                                                                )}
                                                                field="physicianDisplayName"
                                                                filterField="physicianFormattedName"
                                                                optionValue="physicianId"
                                                                onChange={(
                                                                    value,
                                                                    reason
                                                                ) => {
                                                                    if (
                                                                        reason ===
                                                                        'clear'
                                                                    ) {
                                                                        showOptionsAfterClose(
                                                                            'physician',
                                                                            true
                                                                        );

                                                                    }

                                                                    handleInputChangee(
                                                                        'physicianId',
                                                                        value
                                                                    );
                                                                    if (
                                                                        value ==
                                                                        ''
                                                                    ) {
                                                                        setPhysicianValue(
                                                                            ''
                                                                        );
                                                                        handleDisableField(
                                                                            'physician',
                                                                            true
                                                                        );
                                                                    }
                                                                }}
                                                                id="reportUsage-replen-selectShipToWithin-physician"
                                                                zIndex={1000000}
                                                                loading={
                                                                    physiciansOptionLoading
                                                                }
                                                                loadingText={t(
                                                                    'common.loadingText'
                                                                )}
                                                                onInputChange={(
                                                                    event,
                                                                    value,
                                                                    reset
                                                                ) => {
                                                                    if (value) {
                                                                        handleSearche(
                                                                            event,
                                                                            value
                                                                                ? value
                                                                                : defaultPhysicianValue?.physicianDisplayName
                                                                                    ? defaultPhysicianValue?.physicianDisplayName
                                                                                    : '',
                                                                            reset,
                                                                            'physician'
                                                                        );
                                                                    } else if (
                                                                        reset ===
                                                                        'clear'
                                                                    ) {
                                                                        handleSearche(
                                                                            '',
                                                                            '',
                                                                            reset,
                                                                            'physician'
                                                                        );
                                                                    }
                                                                }}
                                                                inputValue={
                                                                    physicianInputValue
                                                                }
                                                                noOptionsText={
                                                                    physicianInputValue?.length >=
                                                                        1
                                                                        ? null
                                                                        : renderNoOption
                                                                }
                                                                onOpen={() => {
                                                                    try {
                                                                        if (
                                                                            disableFormFields
                                                                        ) {
                                                                            handleDisableField(
                                                                                'physician',
                                                                                false
                                                                            );
                                                                        } else {
                                                                            handleDisableField(
                                                                                'physician',
                                                                                true
                                                                            );
                                                                        }
                                                                    } catch (error) {
                                                                        logErrorToConsole(error);
                                                                    }
                                                                }}
                                                                onClose={() => {
                                                                    try {
                                                                        handleDisableField(
                                                                            'physician',
                                                                            false
                                                                        );
                                                                    } catch (error) {
                                                                        logErrorToConsole(error);
                                                                    }
                                                                }}
                                                                open={
                                                                    (surgeryDetails?.physicianId?.physicianFormattedName && surgeryDetails?.physicianId?.physicianFormattedName !== "Other Physician")
                                                                        ? false
                                                                        : disableFields.physician
                                                                }
                                                                optionPadding={
                                                                    physicianInputValue?.length >=
                                                                        1 &&
                                                                        physiciantype ==
                                                                        'All'
                                                                        ? '5px'
                                                                        : '0px'
                                                                }
                                                                readOnly={
                                                                    surgeryDetails?.physicianId?.physicianFormattedName && surgeryDetails?.physicianId?.physicianFormattedName !== "Other Physician"
                                                                }
                                                                detailsMargin
                                                                hideNoOptionText={
                                                                    physiciantype !=
                                                                        'All' &&
                                                                        physicianInputValue?.length >=
                                                                        1
                                                                        ? true
                                                                        : false
                                                                }
                                                                marginLeft={
                                                                    '1.5px'
                                                                }
                                                                style={{
                                                                    height: '40px',
                                                                    width: '100%',
                                                                }}
                                                            />
                                                        </AutoCompleteContainer>
                                                    </MainContainerSecond>
                                                ) : null}
                                                <MainContainerSecond></MainContainerSecond>
                                            </MainContainerThird>
                                        </div>
                                        <CollapsableCard  id="reportUsage-selectShipToAddressDesktop-selectShipToAddress-shippingLabel"
                                            mobileMargin={
                                                isCondensedView &&
                                                '10px -15px 2px -15px'
                                            }
                                            title={t(
                                                'reportUsage.replen.selectShipToAddress.shippingLabel'
                                            )}
                                            onClick={() =>
                                                toggleCard(
                                                    'shipping',
                                                    !expandedCard.shipping
                                                )
                                            }
                                            isExpanded={expandedCard.shipping}
                                            mbPadding={'20px 22px'}
                                            margin={'5px 0px 5px 0px'}
                                            padding={
                                                window.innerWidth >
                                                    sizes.smalDevice
                                                    ? '20px 16px'
                                                    : ''
                                            }
                                        >
                                            {expandedCard.shipping && (
                                                <>
                                                    <Title showAstrisk={true}>
                                                        {t(
                                                            'reportUsage.replen.selectShipToAddress.SelectShipToAddressOutside.shipToAddress'
                                                        )}
                                                    </Title>
                                                    {surgeryDetails?.accountId ===
                                                        undefined ||
                                                        surgeryDetails.accountId ===
                                                        '' ||
                                                        (countryISOCode !== US_COUNTRY_CODE &&
                                                            (!selectedTerritory ||
                                                            (!selectedDistrict &&
                                                                !districts[0]
                                                                    ?.districtName))) ? (
                                                        <>
                                                            <AlertMsg>
                                                                {t(
                                                                    'reportUsage.replen.selectShipToAddress.SelectShipToAddressOutside.alertMsg'
                                                                )}
                                                            </AlertMsg>
                                                        </>
                                                    ) : billToShipToPartnerRole ===
                                                        'BILL_TO' &&
                                                        (surgeryDetails.billToId ===
                                                            '' ||
                                                            surgeryDetails.billToId ===
                                                            undefined) ? (
                                                        <>
                                                            <AlertMsg>
                                                                {t(
                                                                    'reportUsage.replen.selectShipToAddress.SelectShipToAddressOutside.alertMsg1'
                                                                )}
                                                            </AlertMsg>
                                                        </>
                                                    ) : (
                                                        <>
                                                            {!isCondensedView ? (
                                                                <CarousalContainer
                                                                    height={
                                                                        window.innerWidth <=
                                                                            sizes.mobileDevice ||
                                                                            isIpad()
                                                                            ? '195px'
                                                                            : '173px'
                                                                    }
                                                                    overflowX={
                                                                        window.innerWidth <=
                                                                            sizes.smalDevice ||
                                                                            isIpad()
                                                                            ? 'hidden'
                                                                            : 'clip'
                                                                    }
                                                                >
                                                                    <Carousel
                                                                        normalizeInvalidPosition={true}
                                                                        setBottom={
                                                                            window.innerWidth >=
                                                                                sizes.smalDevice
                                                                                ? '-35px'
                                                                                : (window.innerWidth <=
                                                                                    sizes.smalDevice ||
                                                                                    isIpad()) &&
                                                                                '-25%'
                                                                        }
                                                                        carouselPosition={
                                                                            selectedCard
                                                                        }
                                                                        marginRight={window.innerWidth <= 375 ? '16px' : '6.5px'}
                                                                        minWidth={window.innerWidth <= 375 ? '95%' : '98%'}
                                                                        mobileBottom={'0px'}
                                                                    >
                                                                        {nonTissueAddress !==
                                                                            undefined &&
                                                                            nonTissueAddress.length !==
                                                                            0
                                                                            ? nonTissueAddress.map(
                                                                                (
                                                                                    item,
                                                                                    id
                                                                                ) => {
                                                                                    return (
                                                                                        <ShipToCorousalDiv
                                                                                            id={`reportUsage-replen-selectShipToAddress-shipToCorousalDiv-${id}`}
                                                                                            onClick={() => {
                                                                                                try {
                                                                                                    handleShippingToCardClick(
                                                                                                        item,
                                                                                                        id
                                                                                                    );
                                                                                                } catch (error) {
                                                                                                    logErrorToConsole(error);
                                                                                                }
                                                                                            }}
                                                                                            key={
                                                                                                'item' +
                                                                                                id
                                                                                            }
                                                                                        >
                                                                                            <ShippingAddressCard
                                                                                                width={
                                                                                                    '98%'
                                                                                                }
                                                                                                height={
                                                                                                    '164px'
                                                                                                }
                                                                                                boxShadow={
                                                                                                    '0px 0px 6px #00000029'
                                                                                                }
                                                                                                address={
                                                                                                    item
                                                                                                }
                                                                                                isMobileDevice={
                                                                                                    true
                                                                                                }
                                                                                                showBorder={
                                                                                                    selectedCard ===
                                                                                                        id
                                                                                                        ? true
                                                                                                        : false
                                                                                                }
                                                                                            />
                                                                                        </ShipToCorousalDiv>
                                                                                    );
                                                                                }
                                                                            )
                                                                            : null}
                                                                    </Carousel>
                                                                </CarousalContainer>
                                                            ) : (
                                                                <>
                                                                    <AutoComplete
                                                                        customWidth={
                                                                            '46%'
                                                                        }
                                                                        inputRef={
                                                                            shipToRef
                                                                        }
                                                                        showScrollBar={
                                                                            true
                                                                        }
                                                                        disableClearable={
                                                                            false
                                                                        }
                                                                        isFullWidth={
                                                                            true
                                                                        }
                                                                        boxShadow={
                                                                            '0px 3px 6px #00000029'
                                                                        }
                                                                        options={
                                                                            nonTissueAddress &&
                                                                                nonTissueAddress?.length >
                                                                                0 && !shipToAddressLoading
                                                                                ? nonTissueAddress
                                                                                : []
                                                                        }
                                                                        value={
                                                                            shipToInputValue
                                                                        }
                                                                        inputValue={
                                                                            selectedAccount ===
                                                                                ''
                                                                                ? ''
                                                                                : shipToInputValue?.formattedShippingAddressId
                                                                                    ? shipToInputValue?.formattedShippingAddressId
                                                                                    : shipToInputValue?.searchValue
                                                                                        ? shipToInputValue?.searchValue
                                                                                        : ''
                                                                        }
                                                                        clearOnBlur={
                                                                            false
                                                                        }
                                                                        itemTemplate={(
                                                                            option
                                                                        ) =>
                                                                            ShipToOptionTemplate(
                                                                                option
                                                                            )
                                                                        }
                                                                        onChange={(
                                                                            value,
                                                                            reason
                                                                        ) => {
                                                                            if (
                                                                                reason ===
                                                                                'clear'
                                                                            ) {
                                                                                setshipToInputValue(
                                                                                    emptyAddressObj
                                                                                );
                                                                                handleShipToAddress(
                                                                                    'handleInputChange',
                                                                                    '',
                                                                                    '',
                                                                                    reason
                                                                                );
                                                                            } else {
                                                                                handleShipToAddress(
                                                                                    'handleInputChange',
                                                                                    '',
                                                                                    value
                                                                                        ? value
                                                                                        : '',
                                                                                    reason
                                                                                );
                                                                            }
                                                                            if (
                                                                                value ===
                                                                                ''
                                                                            )
                                                                                setOpenShipToAddressDropdown(
                                                                                    true
                                                                                );
                                                                        }}
                                                                        hideNoOptionText={
                                                                            false
                                                                        }
                                                                        placeholder={t(
                                                                            'common.selectOrSearchShipTo'
                                                                        )}
                                                                        field="formattedShippingAddressId"
                                                                        optionValue="formattedShippingAddressId"
                                                                        id={
                                                                            'reportUsage-replen-selectShipTo-shippingAddress'
                                                                        }
                                                                        onInputChange={(
                                                                            event,
                                                                            value,
                                                                            reset
                                                                        ) => {
                                                                            if (
                                                                                value
                                                                            ) {
                                                                                handleShipToAddress(
                                                                                    'handleSearch',
                                                                                    event,
                                                                                    value,
                                                                                    reset
                                                                                );
                                                                            } else if (
                                                                                reset ===
                                                                                'clear'
                                                                            ) {
                                                                                handleShipToAddress(
                                                                                    'handleSearch',
                                                                                    '',
                                                                                    '',
                                                                                    reset
                                                                                );
                                                                            }
                                                                        }}
                                                                        loading={
                                                                            shipToAddressLoading
                                                                        }
                                                                        noOptionsText={
                                                                            !shipToAddressLoading &&
                                                                                nonTissueAddress?.length ===
                                                                                0
                                                                                ? t(
                                                                                    'calendar.filterResultsPanel.noOptionText'
                                                                                )
                                                                                : shipToAddressLoading &&
                                                                                t(
                                                                                    'common.loadingText'
                                                                                )
                                                                        }
                                                                        onFocus={() => {
                                                                            try {
                                                                                setOpenShipToAddressDropdown(
                                                                                    true
                                                                                );
                                                                                const searchValue =
                                                                                    shipToInputValue?.searchValue ??
                                                                                    '';

                                                                                if (
                                                                                    (!searchValue &&
                                                                                        !shipToInputValue?.formattedShippingAddressId &&
                                                                                        nonTissueAddress?.length <
                                                                                        1) ||
                                                                                    nonTissueAddress.length ===
                                                                                    0
                                                                                ) {
                                                                                    handleShipToAddress(
                                                                                        'handleOnFocus',
                                                                                        '',
                                                                                        '',
                                                                                        ''
                                                                                    );
                                                                                }
                                                                            } catch (error) {
                                                                                logErrorToConsole(error);
                                                                            }
                                                                        }}
                                                                        disabled={
                                                                            selectedAccount ===
                                                                            ''
                                                                        }
                                                                        onOpen={() => {
                                                                            try {
                                                                                if (
                                                                                    selectedAccount ===
                                                                                    '' ||
                                                                                    shipToInputValue?.formattedShippingAddressId
                                                                                ) {
                                                                                    setOpenShipToAddressDropdown(
                                                                                        false
                                                                                    );
                                                                                } else {
                                                                                    setOpenShipToAddressDropdown(
                                                                                        true
                                                                                    );
                                                                                }
                                                                            } catch (error) {
                                                                                logErrorToConsole(error);
                                                                            }
                                                                        }}
                                                                        onClose={() =>
                                                                            setOpenShipToAddressDropdown(false)
                                                                        }
                                                                        open={
                                                                            shipToInputValue?.formattedShippingAddressId
                                                                                ? false
                                                                                : openShipToAddressDropdown
                                                                        }
                                                                        readOnly={
                                                                            shipToInputValue?.formattedShippingAddressId
                                                                        }
                                                                        isFromShiptoAddress
                                                                        detailsMargin
                                                                        marginLeft={
                                                                            '1.5px'
                                                                        }
                                                                        zIndex={
                                                                            '99999'
                                                                        }
                                                                    />
                                                                </>
                                                            )}
                                                            <MainContainer
                                                                margin={
                                                                    window.innerWidth <=
                                                                        sizes.mobileDevice
                                                                        ? '0px'
                                                                        : '16px 0px 2px 0px'
                                                                }
                                                                padding={
                                                                    isCondensedView
                                                                        ? '0px'
                                                                        : '20px 15px'
                                                                }
                                                                boxShadow={
                                                                    isCondensedView
                                                                        ? '0px'
                                                                        : '0px 0px 6px #00000029'
                                                                }
                                                                borderRadius={
                                                                    isCondensedView
                                                                        ? '0px'
                                                                        : '6px'
                                                                }
                                                            >
                                                                <ShippingContainer>
                                                                    {attnFieldVisibility ==
                                                                        VISIBLE && (
                                                                            <ShippingContainerSize
                                                                                marginBottom={
                                                                                    '16px'
                                                                                }
                                                                            >
                                                                                <Title
                                                                                    showAstrisk={
                                                                                        false
                                                                                    }
                                                                                >
                                                                                    {t(
                                                                                        'reportUsage.replen.selectShipToAddress.SelectShipToAddressOutside.attn'
                                                                                    )}
                                                                                </Title>
                                                                                <InputBox
                                                                                    placeholder={t(
                                                                                        'common.attentionReceivingOptional'
                                                                                    )}
                                                                                    value={
                                                                                        attnValue
                                                                                    }
                                                                                    id={'reportUsage-replen-selectShipToAddress-selectShipToAddressDesktop-attn'}
                                                                                    maxLength={
                                                                                        40
                                                                                    }
                                                                                    onChange={(
                                                                                        e
                                                                                    ) => {
                                                                                        const value = e.target.value;
                                                                                        const specialCharRegex = /[*$@<>!^]/;
                                                                                        if (specialCharRegex.test(value)) {
                                                                                            setAttnErrorMsg('Special Characters(*$@<>!^) not allowed');
                                                                                        } else {
                                                                                            setAttnErrorMsg('');
                                                                                        }
                                                                                        setAttnValue(value);
                                                                                    }}
                                                                                />
                                                                                {attnErrorMsg && (
                                                                                    <AlertMsg>
                                                                                        {attnErrorMsg}
                                                                                    </AlertMsg>
                                                                                )}
                                                                            </ShippingContainerSize>
                                                                        )}

                                                                    {careOfFieldVisibilityZLCR ===
                                                                        'VISIBLE' && (
                                                                            <ShippingContainerSize
                                                                                flexBasis="46%"
                                                                                marginBottom={
                                                                                    // window.innerWidth <=
                                                                                    // sizes.smalDevice
                                                                                    //     ? '16px'
                                                                                    //     :
                                                                                    '16px'
                                                                                }
                                                                            >
                                                                                <Title
                                                                                    showAstrisk={
                                                                                        careOfFieldMandatory ===
                                                                                        MANDATORY
                                                                                    }
                                                                                >
                                                                                    {t(
                                                                                        'reportUsage.replen.selectShipToAddress.careOf'
                                                                                    )}
                                                                                </Title>
                                                                                {/* )} */}

                                                                                <InputBox className="report-usage-shipping-contact-input-dt-mask"
                                                                                    borderRadius="4px"
                                                                                    isBorderColor={
                                                                                        true
                                                                                    }
                                                                                    placeholder={t(
                                                                                        'reportUsage.replen.selectShipToAddress.careOfPlaceholder'
                                                                                    )} //need to move to string file
                                                                                    value={
                                                                                        careOfValue
                                                                                    }
                                                                                    id={'reportUsage-replen-selectShipToAddress-selectShipToAddressDesktop-careOf'}
                                                                                    onChange={(
                                                                                        e
                                                                                    ) => {
                                                                                        setCareOfValue(
                                                                                            e
                                                                                                .target
                                                                                                .value
                                                                                        );
                                                                                    }}
                                                                                    maxLength={
                                                                                        30
                                                                                    }
                                                                                />
                                                                            </ShippingContainerSize>
                                                                        )}
                                                                   { usageReplenishmentSurgeryDateVisibility ===
                                                                        VISIBLE && (
                                                                            <ShippingContainerSize flexBasis="46%">
                                                                                <MainContainerItems
                                                                                    width={
                                                                                        '100%'
                                                                                    }
                                                                                    isReplenish={
                                                                                        true
                                                                                    }
                                                                                    setMarginBottom={
                                                                                        '10px'
                                                                                    }
                                                                                    // setMarginTop={
                                                                                    //     'replenish'
                                                                                    // }
                                                                                    setMarginleft={
                                                                                        // window.innerWidth <=
                                                                                        // sizes.mobileDevice ?
                                                                                        '0px'
                                                                                        //: '55%'
                                                                                    }
                                                                                    mbMarginBottom="16px"
                                                                                >
                                                                                    <Title
                                                                                        showAstrisk={
                                                                                            usageReplenishmentSurgeryDateMandatoryRule ===
                                                                                                'YES'
                                                                                                ? true
                                                                                                : false
                                                                                        }
                                                                                    >
                                                                                        {t(
                                                                                            'common.surgeryDateLabel'
                                                                                        )}
                                                                                    </Title>
                                                                                    <SurgeryDateView>
                                                                                        <DatePicker
                                                                                            onChange={(
                                                                                                value
                                                                                            ) => {
                                                                                                handleSurgeryDate(
                                                                                                    value,
                                                                                                    true
                                                                                                );
                                                                                            }}
                                                                                            selectedDateFromDatePicker={
                                                                                                surgeryDate
                                                                                            }
                                                                                            enableMinDate={
                                                                                                false
                                                                                            }
                                                                                            minDate={
                                                                                                new Date(
                                                                                                    // excludesWeekendsForSurgeryDate()
                                                                                                    // businessDays[0]
                                                                                                    new Date()
                                                                                                )
                                                                                            }
                                                                                            // // minDate={
                                                                                            //     new Date(
                                                                                            //         moment().subtract(3, 'd')
                                                                                            //     )
                                                                                            // }
                                                                                            // icon={Calendar}
                                                                                            datePickerCalendarIcon={
                                                                                                Calendar
                                                                                            }
                                                                                            placeholder={t(
                                                                                                'common.surgeryDateLabel'
                                                                                            )}
                                                                                            datePickerBgColor="unset"
                                                                                            datePickerDivWidth={
                                                                                                window.innerWidth ==
                                                                                                    '820'
                                                                                                    ? '100%'
                                                                                                    : window.innerWidth ==
                                                                                                        '768'
                                                                                                        ? '100%'
                                                                                                        : '100%'
                                                                                            }
                                                                                            datePickerDivHeight="40px"
                                                                                            fontSize="16px"
                                                                                            left="10px"
                                                                                            iconHeight="40px"
                                                                                            datePopOverZIndex="100000"
                                                                                            iconRight="0px"
                                                                                            iconPaddingTop="7px"
                                                                                            datePickerDivMbWidth={
                                                                                                '100%'
                                                                                            }
                                                                                            smbWidth={
                                                                                                '142px'
                                                                                            }
                                                                                            smbIconPaddingTop={
                                                                                                '0px'
                                                                                            }
                                                                                            smbIconheight={
                                                                                                '40px'
                                                                                            }
                                                                                            borderRadius="4px"
                                                                                            datePickerDivMbHeight="40px"
                                                                                            mbWidth={
                                                                                                '100%'
                                                                                            }
                                                                                        />
                                                                                    </SurgeryDateView>
                                                                                </MainContainerItems>
                                                                            </ShippingContainerSize>
                                                                        )}
                                                                    {/* {window.innerWidth >=
                                                                    sizes.mobileDevice
                                                                        ? usageReplenishmentSurgeryDateVisibility ===
                                                                              VISIBLE && (
                                                                              <ShippingContainerSize flexBasis="46%">
                                                                                  <MainContainerItems
                                                                                      width={
                                                                                          '100%'
                                                                                      }
                                                                                      isReplenish={
                                                                                          true
                                                                                      }
                                                                                      setMarginBottom={
                                                                                          '10px'
                                                                                      }
                                                                                      // setMarginTop={
                                                                                      //     'replenish'
                                                                                      // }
                                                                                      setMarginleft={
                                                                                          // window.innerWidth <=
                                                                                          // sizes.mobileDevice ?
                                                                                          '0px'
                                                                                          //: '55%'
                                                                                      }
                                                                                      mbMarginBottom="16px"
                                                                                  >
                                                                                      <Title
                                                                                          showAstrisk={
                                                                                              usageReplenishmentSurgeryDateMandatoryRule ===
                                                                                              'YES'
                                                                                                  ? true
                                                                                                  : false
                                                                                          }
                                                                                      >
                                                                                          {t(
                                                                                              'common.surgeryDateLabel'
                                                                                          )}
                                                                                      </Title>
                                                                                      <SurgeryDateView>
                                                                                          <DatePicker
                                                                                              onChange={(
                                                                                                  value
                                                                                              ) => {
                                                                                                  handleSurgeryDate(
                                                                                                      value,
                                                                                                      true
                                                                                                  );
                                                                                              }}
                                                                                              selectedDateFromDatePicker={
                                                                                                  surgeryDate
                                                                                              }
                                                                                              enableMinDate={
                                                                                                  false
                                                                                              }
                                                                                              minDate={
                                                                                                  new Date(
                                                                                                      // excludesWeekendsForSurgeryDate()
                                                                                                      // businessDays[0]
                                                                                                      new Date()
                                                                                                  )
                                                                                              }
                                                                                              // // minDate={
                                                                                              //     new Date(
                                                                                              //         moment().subtract(3, 'd')
                                                                                              //     )
                                                                                              // }
                                                                                              // icon={Calendar}
                                                                                              datePickerCalendarIcon={
                                                                                                  Calendar
                                                                                              }
                                                                                              placeholder={t(
                                                                                                  'common.surgeryDateLabel'
                                                                                              )}
                                                                                              datePickerBgColor="unset"
                                                                                              datePickerDivWidth={
                                                                                                  window.innerWidth ==
                                                                                                  '820'
                                                                                                      ? '100%'
                                                                                                      : window.innerWidth ==
                                                                                                        '768'
                                                                                                      ? '100%'
                                                                                                      : '100%'
                                                                                              }
                                                                                              datePickerDivHeight="40px"
                                                                                              fontSize="16px"
                                                                                              left="10px"
                                                                                              iconHeight="40px"
                                                                                              datePopOverZIndex="100000"
                                                                                              iconRight="0px"
                                                                                              iconPaddingTop="7px"
                                                                                              datePickerDivMbWidth={
                                                                                                  '100%'
                                                                                              }
                                                                                              smbWidth={
                                                                                                  '142px'
                                                                                              }
                                                                                              smbIconPaddingTop={
                                                                                                  '0px'
                                                                                              }
                                                                                              smbIconheight={
                                                                                                  '40px'
                                                                                              }
                                                                                              borderRadius="4px"
                                                                                              datePickerDivMbHeight="40px"
                                                                                              mbWidth={
                                                                                                  '100%'
                                                                                              }
                                                                                          />
                                                                                      </SurgeryDateView>
                                                                                  </MainContainerItems>
                                                                              </ShippingContainerSize>
                                                                          )
                                                                        :  transferRecipientMeta.includes(shippingMethodValue?.shippingMethodId) 
                                                                               && (
                                                                              <ShippingContainerSize
                                                                                  flexBasis="46%"
                                                                                  marginBottom={
                                                                                      //   window.innerWidth <=
                                                                                      //   sizes.smalDevice
                                                                                      //       ? '16px'
                                                                                      //       :
                                                                                      '16px'
                                                                                  }
                                                                              >
                                                                                  <Title
                                                                                      display={
                                                                                          'flex'
                                                                                      }
                                                                                  >
                                                                                      {t(
                                                                                          'reportUsage.replen.selectShipToAddress.transferRecipient'
                                                                                      )}
                                                                                      <Title
                                                                                          marginBottom={
                                                                                              true
                                                                                          }
                                                                                          color={
                                                                                              '#ED002A'
                                                                                          }
                                                                                          showAstrisk={transferRecipientMandatory === MANDATORY}
                                                                                      >{`\u00A0${t(
                                                                                          'common.transferRecipientImportantMsg'
                                                                                      )}`}</Title>
                                                                                  </Title>
                                                                                  <AutoComplete
                                                                                      inputRef={
                                                                                          transferRecipientRef
                                                                                      }
                                                                                      showScrollBar={
                                                                                          true
                                                                                      }
                                                                                      disableClearable={
                                                                                          false
                                                                                      }
                                                                                      isFullWidth={
                                                                                          true
                                                                                      }
                                                                                      boxShadow={
                                                                                          '0px 3px 6px #00000029'
                                                                                      }
                                                                                      options={
                                                                                          transferRecipient &&
                                                                                          transferRecipient?.length >
                                                                                              0
                                                                                              ? transferRecipient
                                                                                              : []
                                                                                      }
                                                                                      value={
                                                                                          transferRecipientSelectedValue ??
                                                                                          ''
                                                                                      }
                                                                                      inputValue={
                                                                                         selectedAccount !== ''
                                                                                            ? transferRecipientValue?.accountName
                                                                                                ? transferRecipientValue?.accountName
                                                                                                : transferRecipientSelectedValue || ''  
                                                                                            : ''
                                                                                      }
                                                                                      clearOnBlur={
                                                                                          false
                                                                                      }
                                                                                      itemTemplate={(
                                                                                          option
                                                                                      ) =>
                                                                                          OptionTransferRecipient(
                                                                                              option
                                                                                          )
                                                                                      }
                                                                                      onChange={(
                                                                                          value,
                                                                                          reason
                                                                                      ) => { 
                                                                                          if (
                                                                                              reason ===
                                                                                              'clear'
                                                                                          ) {
                                                                                              handleTransferRecipient(
                                                                                                  'handleInputChange',
                                                                                                  '',
                                                                                                  '',
                                                                                                  true
                                                                                              );
                                                                                          } 
                                                                                          handleTransferRecipient(
                                                                                              'handleInputChange',
                                                                                              '',
                                                                                              value
                                                                                                  ? value
                                                                                                  : '',
                                                                                              reason
                                                                                          );
                                                                                          if (
                                                                                              value ===
                                                                                              ''
                                                                                          )
                                                                                              setOpenTransferRecipientDropdown(
                                                                                                  true
                                                                                              );
                                                                                      }}
                                                                                      hideNoOptionText={
                                                                                          false
                                                                                      }
                                                                                      placeholder={t(
                                                                                          'reportUsage.replen.selectShipToAddress.transferRecipientPlaceholder'
                                                                                      )}
                                                                                      field="accountName"
                                                                                      optionValue="accountName"
                                                                                      id={
                                                                                          'reportUsage-replen-selectShipTo-transferRecipient'
                                                                                      }
                                                                                      onInputChange={(
                                                                                          event,
                                                                                          value,
                                                                                          reset
                                                                                      ) => {
                                                                                          if (
                                                                                              value
                                                                                          ) {
                                                                                              value?.length !==
                                                                                              11
                                                                                                  ? handleTransferRecipient(
                                                                                                        'handleSearch',
                                                                                                        event,
                                                                                                        value
                                                                                                            ? value
                                                                                                            : '',
                                                                                                        reset
                                                                                                    )
                                                                                                  : () => {};
                                                                                          } else if (
                                                                                              reset ===
                                                                                              'clear'
                                                                                          ) {
                                                                                              handleTransferRecipient(
                                                                                                  'handleSearch',
                                                                                                  '',
                                                                                                  '',
                                                                                                  reset
                                                                                              );
                                                                                          }
                                                                                      }}
                                                                                      loading={
                                                                                          transferRecipientLoading
                                                                                      }
                                                                                      noOptionsText={
                                                                                          !transferRecipientLoading &&
                                                                                          transferRecipient?.length ===
                                                                                              0
                                                                                              ? t(
                                                                                                    'calendar.filterResultsPanel.noOptionText'
                                                                                                )
                                                                                              : transferRecipientLoading &&
                                                                                                t(
                                                                                                    'common.loadingText'
                                                                                                )
                                                                                      }
                                                                                      onFocus={(
                                                                                          event
                                                                                      ) =>
                                                                                          handleTransferRecipient(
                                                                                              'handleOnFocus',
                                                                                              event
                                                                                          )
                                                                                      }
                                                                                      disabled={
                                                                                          selectedAccount ===
                                                                                          ''
                                                                                      }
                                                                                      onOpen={() => {
                                                                                        try {
                                                                                          if (
                                                                                              selectedAccount ===
                                                                                              ''
                                                                                          ) {
                                                                                              setOpenTransferRecipientDropdown(
                                                                                                  false
                                                                                              );
                                                                                          } else {
                                                                                              setOpenTransferRecipientDropdown(
                                                                                                  true
                                                                                              );
                                                                                          }
                                                                                          } catch (error) {
                                                                                              logErrorToConsole(error);
                                                                                           }
                                                                                      }}
                                                                                      onClose={() => {
                                                                                        try {
                                                                                          setOpenTransferRecipientDropdown(
                                                                                              false
                                                                                          );
                                                                                          } catch (error) {
                                                                                              logErrorToConsole(error);
                                                                                          }
                                                                                      }}
                                                                                      open={
                                                                                          transferRecipientValue?.accountName
                                                                                              ? false
                                                                                              : openTransferRecipientDropdown
                                                                                      }
                                                                                      readOnly={
                                                                                          transferRecipientValue?.accountName
                                                                                      }
                                                                                      detailsMargin
                                                                                      marginLeft={
                                                                                          '1.5px'
                                                                                      }
                                                                                      zIndex={
                                                                                          '99999'
                                                                                      }
                                                                                  />
                                                                              </ShippingContainerSize>
                                                                          )} */}
                                                                    {/* {window.innerWidth >=
                                                                    sizes.mobileDevice
                                                                        ?  transferRecipientMeta.includes(shippingMethodValue?.shippingMethodId) 
                                                                               && (
                                                                              <ShippingContainerSize
                                                                                  flexBasis="46%"
                                                                                  marginBottom={
                                                                                      //   window.innerWidth <=
                                                                                      //   sizes.smalDevice
                                                                                      //       ? '16px'
                                                                                      //   :
                                                                                      '16px'
                                                                                  }
                                                                              >
                                                                                  <Title
                                                                                      display={
                                                                                          'flex'
                                                                                      }
                                                                                  >
                                                                                      {t(
                                                                                          'reportUsage.replen.selectShipToAddress.transferRecipient'
                                                                                      )}
                                                                                      <Title
                                                                                          marginBottom={
                                                                                              true
                                                                                          }
                                                                                          color={
                                                                                              '#ED002A'
                                                                                          }
                                                                                          showAstrisk={transferRecipientMandatory === MANDATORY}
                                                                                      >{`\u00A0${t(
                                                                                          'common.transferRecipientImportantMsg'
                                                                                      )}`}</Title>
                                                                                  </Title>
                                                                                  <AutoComplete
                                                                                      inputRef={
                                                                                          transferRecipientRef
                                                                                      }
                                                                                      showScrollBar={
                                                                                          true
                                                                                      }
                                                                                      disableClearable={
                                                                                          false
                                                                                      }
                                                                                      isFullWidth={
                                                                                          true
                                                                                      }
                                                                                      boxShadow={
                                                                                          '0px 3px 6px #00000029'
                                                                                      }
                                                                                      options={
                                                                                          transferRecipient &&
                                                                                          transferRecipient?.length >
                                                                                              0
                                                                                              ? transferRecipient
                                                                                              : []
                                                                                      }
                                                                                      value={
                                                                                          transferRecipientSelectedValue ??
                                                                                          ''
                                                                                      }
                                                                                      inputValue={
                                                                                          selectedAccount !== ''
                                                                                            ? transferRecipientValue?.accountName
                                                                                                ? transferRecipientValue?.accountName
                                                                                                : transferRecipientSelectedValue || ''  
                                                                                            : ''
                                                                                            
                                                                                      }
                                                                                      clearOnBlur={
                                                                                          false
                                                                                      }
                                                                                      itemTemplate={(
                                                                                          option
                                                                                      ) =>
                                                                                          OptionTransferRecipient(
                                                                                              option
                                                                                          )
                                                                                      }
                                                                                      onChange={(
                                                                                          value,
                                                                                          reason
                                                                                      ) => { 
                                                                                          if (
                                                                                              reason ===
                                                                                              'clear'
                                                                                          ) {
                                                                                              handleTransferRecipient(
                                                                                                  'handleInputChange',
                                                                                                  '',
                                                                                                  '',
                                                                                                  true
                                                                                              );
                                                                                          }
                                                                                          handleTransferRecipient(
                                                                                              'handleInputChange',
                                                                                              '',
                                                                                              value
                                                                                                  ? value
                                                                                                  : '',
                                                                                              reason
                                                                                          );
                                                                                          if (
                                                                                              value ===
                                                                                              ''
                                                                                          )
                                                                                              setOpenTransferRecipientDropdown(
                                                                                                  true
                                                                                              );
                                                                                      }}
                                                                                      hideNoOptionText={
                                                                                          false
                                                                                      }
                                                                                      placeholder={t(
                                                                                          'reportUsage.replen.selectShipToAddress.transferRecipientPlaceholder'
                                                                                      )}
                                                                                      field="accountName"
                                                                                      optionValue="accountName"
                                                                                      id={
                                                                                          'reportUsage-replen-selectShipTo-transferRecipient'
                                                                                      }
                                                                                      onInputChange={(
                                                                                          event,
                                                                                          value,
                                                                                          reset
                                                                                      ) => {
                                                                                          if (
                                                                                              value
                                                                                          ) {
                                                                                              value?.length !==
                                                                                              11
                                                                                                  ? handleTransferRecipient(
                                                                                                        'handleSearch',
                                                                                                        event,
                                                                                                        value
                                                                                                            ? value
                                                                                                            : '',
                                                                                                        reset
                                                                                                    )
                                                                                                  : () => {};
                                                                                          } else if (
                                                                                              reset ===
                                                                                              'clear'
                                                                                          ) {
                                                                                              handleTransferRecipient(
                                                                                                  'handleSearch',
                                                                                                  '',
                                                                                                  '',
                                                                                                  reset
                                                                                              );
                                                                                          }
                                                                                      }}
                                                                                      loading={
                                                                                          transferRecipientLoading
                                                                                      }
                                                                                      noOptionsText={
                                                                                          !transferRecipientLoading &&
                                                                                          transferRecipient?.length ===
                                                                                              0
                                                                                              ? t(
                                                                                                    'calendar.filterResultsPanel.noOptionText'
                                                                                                )
                                                                                              : transferRecipientLoading &&
                                                                                                t(
                                                                                                    'common.loadingText'
                                                                                                )
                                                                                      }
                                                                                      onFocus={(
                                                                                          event
                                                                                      ) =>
                                                                                          handleTransferRecipient(
                                                                                              'handleOnFocus',
                                                                                              event
                                                                                          )
                                                                                      }
                                                                                      disabled={
                                                                                          selectedAccount ===
                                                                                          ''
                                                                                      }
                                                                                      onOpen={() => {
                                                                                        try {
                                                                                          if (
                                                                                              selectedAccount ===
                                                                                              ''
                                                                                          ) {
                                                                                              setOpenTransferRecipientDropdown(
                                                                                                  false
                                                                                              );
                                                                                          } else {
                                                                                              setOpenTransferRecipientDropdown(
                                                                                                  true
                                                                                              );
                                                                                          }
                                                                                          } catch (error) {
                                                                                               logErrorToConsole(error);
                                                                                           }
                                                                                      }}
                                                                                      onClose={() => {
                                                                                        try {
                                                                                          setOpenTransferRecipientDropdown(
                                                                                              false
                                                                                          );
                                                                                          } catch (error) {
                                                                                             logErrorToConsole(error);
                                                                                          }
                                                                                      }}
                                                                                      open={
                                                                                          transferRecipientValue?.accountName
                                                                                              ? false
                                                                                              : openTransferRecipientDropdown
                                                                                      }
                                                                                      readOnly={
                                                                                          transferRecipientValue?.accountName
                                                                                      }
                                                                                      detailsMargin
                                                                                      marginLeft={
                                                                                          '1.5px'
                                                                                      }
                                                                                      zIndex={
                                                                                          '99999'
                                                                                      }
                                                                                  />
                                                                              </ShippingContainerSize>
                                                                          )
                                                                        : usageReplenishmentSurgeryDateVisibility ===
                                                                              VISIBLE && (
                                                                              <ShippingContainerSize flexBasis="46%">
                                                                                  <MainContainerItems
                                                                                      width={
                                                                                          '100%'
                                                                                      }
                                                                                      isReplenish={
                                                                                          true
                                                                                      }
                                                                                      setMarginBottom={
                                                                                          '16px'
                                                                                      }
                                                                                      // setMarginTop={
                                                                                      //     'replenish'
                                                                                      // }
                                                                                      setMarginleft={
                                                                                          // window.innerWidth <=
                                                                                          // sizes.mobileDevice ?
                                                                                          '0px'
                                                                                          //: '55%'
                                                                                      }
                                                                                      mbMarginBottom="16px"
                                                                                  >
                                                                                      <Title
                                                                                          showAstrisk={
                                                                                              usageReplenishmentSurgeryDateMandatoryRule ===
                                                                                              'YES'
                                                                                                  ? true
                                                                                                  : false
                                                                                          }
                                                                                      >
                                                                                          {t(
                                                                                              'common.surgeryDateLabel'
                                                                                          )}
                                                                                      </Title>
                                                                                      <SurgeryDateView>
                                                                                          <DatePicker
                                                                                              onChange={(
                                                                                                  value
                                                                                              ) => {
                                                                                                  handleSurgeryDate(
                                                                                                      value,
                                                                                                      true
                                                                                                  );
                                                                                              }}
                                                                                              selectedDateFromDatePicker={
                                                                                                  surgeryDate
                                                                                              }
                                                                                              enableMinDate={
                                                                                                  false
                                                                                              }
                                                                                              minDate={
                                                                                                  new Date(
                                                                                                      // excludesWeekendsForSurgeryDate()
                                                                                                      // businessDays[0]
                                                                                                      new Date()
                                                                                                  )
                                                                                              }
                                                                                              // // minDate={
                                                                                              //     new Date(
                                                                                              //         moment().subtract(3, 'd')
                                                                                              //     )
                                                                                              // }
                                                                                              // icon={Calendar}
                                                                                              datePickerCalendarIcon={
                                                                                                  Calendar
                                                                                              }
                                                                                              placeholder={t(
                                                                                                  'common.surgeryDateLabel'
                                                                                              )}
                                                                                              datePickerBgColor="unset"
                                                                                              datePickerDivWidth={
                                                                                                  window.innerWidth ==
                                                                                                  '820'
                                                                                                      ? '100%'
                                                                                                      : window.innerWidth ==
                                                                                                        '768'
                                                                                                      ? '100%'
                                                                                                      : '100%'
                                                                                              }
                                                                                              datePickerDivHeight="40px"
                                                                                              fontSize="16px"
                                                                                              left="10px"
                                                                                              iconHeight="40px"
                                                                                              datePopOverZIndex="100000"
                                                                                              iconRight="0px"
                                                                                              iconPaddingTop="7px"
                                                                                              datePickerDivMbWidth={
                                                                                                  '100%'
                                                                                              }
                                                                                              smbWidth={
                                                                                                  '142px'
                                                                                              }
                                                                                              smbIconPaddingTop={
                                                                                                  '0px'
                                                                                              }
                                                                                              smbIconheight={
                                                                                                  '40px'
                                                                                              }
                                                                                              borderRadius="4px"
                                                                                              datePickerDivMbHeight="40px"
                                                                                              mbWidth={
                                                                                                  '100%'
                                                                                              }
                                                                                          />
                                                                                      </SurgeryDateView>
                                                                                  </MainContainerItems>
                                                                              </ShippingContainerSize>
                                                                          )} */}
                                                                    {requestedDeliveryDateVisibility ===
                                                                        VISIBLE && (
                                                                            <ShippingContainerSize flexBasis="46%">
                                                                                <MainContainerItems
                                                                                    width={
                                                                                        '100%'
                                                                                    }
                                                                                    isReplenish={
                                                                                        true
                                                                                    }
                                                                                    setMarginBottom={
                                                                                        '16px'
                                                                                    }
                                                                                    // setMarginTop={
                                                                                    //     'replenish'
                                                                                    // }
                                                                                    setMarginleft={
                                                                                        // window.innerWidth <=
                                                                                        // sizes.mobileDevice ?
                                                                                        '0px'
                                                                                        //: '55%'
                                                                                    }
                                                                                    mbMarginBottom="16px"
                                                                                >
                                                                                    <Title
                                                                                        showAstrisk={
                                                                                            requestedDeliveryDateMandatory ===
                                                                                                'YES' ||
                                                                                                requestedDeliveryDateMandatory ===
                                                                                                'yes'
                                                                                                ? true
                                                                                                : false
                                                                                        }
                                                                                    >
                                                                                        {t(
                                                                                            'common.requestedDeliveryDateLabel'
                                                                                        )}
                                                                                    </Title>
                                                                                    <RequestDeliveryDateView>
                                                                                        <DatePicker
                                                                                            onChange={(
                                                                                                value
                                                                                            ) => {
                                                                                                handleRequestDeliveryDate(
                                                                                                    value,
                                                                                                    true,
                                                                                                    '',
                                                                                                    false
                                                                                                );
                                                                                            }}
                                                                                            disabled={
                                                                                                selectedAccount ===
                                                                                                    '' ||
                                                                                                    selectedAccount ===
                                                                                                    undefined
                                                                                                    ? true
                                                                                                    : usageReplenishmentSurgeryDateVisibility ===
                                                                                                        VISIBLE &&
                                                                                                        surgeryDate
                                                                                                        ? new Date(
                                                                                                            surgeryDate
                                                                                                        ).setHours(
                                                                                                            0,
                                                                                                            0,
                                                                                                            0,
                                                                                                            0
                                                                                                        ) ===
                                                                                                            new Date().setHours(
                                                                                                                0,
                                                                                                                0,
                                                                                                                0,
                                                                                                                0
                                                                                                            )
                                                                                                            ? getDisable()
                                                                                                                ? false
                                                                                                                : true
                                                                                                            : getDisable()
                                                                                                                ? false
                                                                                                                : true
                                                                                                        : usageReplenishmentSurgeryDateVisibility !==
                                                                                                            VISIBLE
                                                                                                            ? false
                                                                                                            : true
                                                                                            }
                                                                                            rdd={
                                                                                                true
                                                                                            }
                                                                                            selectedDateFromDatePicker={
                                                                                                RequestDeliveryDate
                                                                                            }
                                                                                            minDate={
                                                                                                requestedDeliveryDateCutOffTime
                                                                                                    ? new Date(
                                                                                                        japanMinimunDate[0]
                                                                                                    )
                                                                                                    : getTomorrowDate()
                                                                                            }
                                                                                            enableMinDate={
                                                                                                requestedDeliveryDateCutOffTime
                                                                                                    ? getDisabledDatesBasedOnJapanTime(
                                                                                                        new Date(),
                                                                                                        false,
                                                                                                        requestedDeliveryDateCutOffTime,
                                                                                                        surgeryDetails?.accountId
                                                                                                    )
                                                                                                    : [
                                                                                                        new Date(),
                                                                                                    ]
                                                                                            }
                                                                                            maxDate={
                                                                                                nextDay
                                                                                                    ? getTomorrowDate(
                                                                                                        [],
                                                                                                        enableRequestedDeliveryDateForWeekEnd !==
                                                                                                        VISIBLE &&
                                                                                                        true
                                                                                                    )
                                                                                                    : getNumberOfDaysBetweenTwoDates(
                                                                                                        new Date(),
                                                                                                        new Date(
                                                                                                            surgeryDate
                                                                                                        )
                                                                                                    ) <
                                                                                                        4 &&
                                                                                                        new Date(
                                                                                                            surgeryDate
                                                                                                        ).getDay() ===
                                                                                                        1 &&
                                                                                                        countryISOCode !==
                                                                                                        COUNTRY_CODE_JAPN
                                                                                                        ? new Date(
                                                                                                            surgeryDate
                                                                                                        )
                                                                                                        : currentDateDelivery ===
                                                                                                            VISIBLE &&
                                                                                                            new Date(
                                                                                                                surgeryDate
                                                                                                            ).setHours(
                                                                                                                0,
                                                                                                                0,
                                                                                                                0,
                                                                                                                0
                                                                                                            ) ===
                                                                                                            new Date().setHours(
                                                                                                                0,
                                                                                                                0,
                                                                                                                0,
                                                                                                                0
                                                                                                            )
                                                                                                            ? new Date()
                                                                                                            : allDayRequestedDeliveryDate ===
                                                                                                                VISIBLE
                                                                                                                ? new Date(
                                                                                                                    surgeryDate
                                                                                                                )
                                                                                                                : moment(
                                                                                                                    new Date(
                                                                                                                        surgeryDate
                                                                                                                    )
                                                                                                                )
                                                                                                                    .startOf(
                                                                                                                        'day'
                                                                                                                    )
                                                                                                                    .subtract(
                                                                                                                        1,
                                                                                                                        'days'
                                                                                                                    )
                                                                                                                    .toDate()
                                                                                            }
                                                                                            disableWeekEnds={
                                                                                                requestedDeliveryDateVisibility ===
                                                                                                    VISIBLE &&
                                                                                                    enableRequestedDeliveryDateForWeekEnd ===
                                                                                                    VISIBLE
                                                                                                    ? ''
                                                                                                    : [
                                                                                                        0,
                                                                                                        6,
                                                                                                    ]
                                                                                            }
                                                                                            datePickerCalendarIcon={
                                                                                                Calendar
                                                                                            }
                                                                                            placeholder={t(
                                                                                                'common.requestDeliveryDateDatePlaceHplder'
                                                                                            )}
                                                                                            datePickerBgColor="unset"
                                                                                            datePickerDivWidth={
                                                                                                window.innerWidth ==
                                                                                                    '820'
                                                                                                    ? '100%'
                                                                                                    : window.innerWidth ==
                                                                                                        '768'
                                                                                                        ? '100%'
                                                                                                        : '100%'
                                                                                            }
                                                                                            datePickerDivHeight="40px"
                                                                                            fontSize="16px"
                                                                                            left="10px"
                                                                                            iconHeight="40px"
                                                                                            datePopOverZIndex="100000"
                                                                                            iconPaddingTop="7px"
                                                                                            iconRight="0px"
                                                                                            datePickerDivMbWidth={
                                                                                                '100%'
                                                                                            }
                                                                                            smbWidth={
                                                                                                '142px'
                                                                                            }
                                                                                            smbIconPaddingTop={
                                                                                                '0px'
                                                                                            }
                                                                                            smbIconheight={
                                                                                                '40px'
                                                                                            }
                                                                                            borderRadius="4px"
                                                                                            datePickerDivMbHeight="40px"
                                                                                        />
                                                                                    </RequestDeliveryDateView>
                                                                                </MainContainerItems>
                                                                            </ShippingContainerSize>
                                                                        )}

                                                                    {surgeryNumberUsageReplenishmentVisibility ===
                                                                        VISIBLE && (
                                                                            <ShippingContainerSize flexBasis="46%">
                                                                                <MainContainerItems
                                                                                    width={
                                                                                        '100%'
                                                                                    }
                                                                                    isReplenish={
                                                                                        true
                                                                                    }
                                                                                    setMarginBottom={
                                                                                        '16px'
                                                                                    }
                                                                                    // setMarginTop={
                                                                                    //     'replenish'
                                                                                    // }
                                                                                    setMarginleft={
                                                                                        // window.innerWidth <=
                                                                                        // sizes.mobileDevice ?
                                                                                        '0px'
                                                                                        //: '55%'
                                                                                    }
                                                                                    mbMarginBottom="16px"
                                                                                >
                                                                                    {/* <ShippingContainerSize
                                                                                isReportReplenishment={
                                                                                    window.innerWidth <=
                                                                                        sizes.mobileDevice &&
                                                                                    true
                                                                                }
                                                                            > */}
                                                                                    {/* <SurgeryDateViewAndNumber
                                                                                    isReportReplenishment={
                                                                                        true
                                                                                    }
                                                                                    isSurgeryDate={
                                                                                        usageReplenishmentSurgeryDateVisibility ===
                                                                                        'VISIBLE'
                                                                                    }
                                                                                > */}
                                                                                    <Title
                                                                                        showAstrisk={
                                                                                            surgeryNumberUsageReplenishmentMandatory ===
                                                                                                'YES'
                                                                                                ? true
                                                                                                : false
                                                                                        }
                                                                                    >
                                                                                        {t(
                                                                                            'common.surgeryNumberLabel'
                                                                                        )}
                                                                                    </Title>

                                                                                    <Select
                                                                                        id="reportUsage-selectShipToAddressDesktop-selectShipToAddress-surgeryNameLabel"
                                                                                        value={
                                                                                            numberOfSurgery
                                                                                        }
                                                                                        options={
                                                                                            DropdownOption()
                                                                                                .numberOfSurgery
                                                                                        }
                                                                                        onChange={(
                                                                                            count
                                                                                        ) => {
                                                                                            setNumberOfSurgery(
                                                                                                count
                                                                                            );
                                                                                        }}
                                                                                        width={
                                                                                            '100%'
                                                                                        }
                                                                                        smWidth="100%"
                                                                                        xSmWidth="40%"
                                                                                        defaultValue={
                                                                                            numberOfSurgery
                                                                                        }
                                                                                    />
                                                                                    {/* </SurgeryDateViewAndNumber>
                                                                            </ShippingContainerSize> */}
                                                                                </MainContainerItems>
                                                                            </ShippingContainerSize>
                                                                        )}

                                                                    <ShippingContainerSize
                                                                        flexBasis="46%"
                                                                        marginBottom={
                                                                            // window.innerWidth <=
                                                                            // sizes.smalDevice
                                                                            //     ? '16px'
                                                                            // :
                                                                            '16px'
                                                                        }
                                                                    >
                                                                        <Title
                                                                            showAstrisk={
                                                                                true
                                                                            }
                                                                            display={
                                                                                'flex'
                                                                            }
                                                                        >
                                                                            {t(
                                                                                'reportUsage.replen.replenListView.shippingMethod'
                                                                            )}
                                                                            <Title
                                                                                marginBottom={
                                                                                    true
                                                                                }
                                                                                color={
                                                                                    '#ED002A'
                                                                                }
                                                                            >
                                                                                {`\u00A0${t(
                                                                                    'common.shippingMethodImportantMsg'
                                                                                )}`}
                                                                            </Title>
                                                                        </Title>
                                                                        <Select
                                                                            id="reportUsage-selectShipToAddressDesktop-selectShipToAddress-shippingMethodName"
                                                                            width={
                                                                                '100%'
                                                                            }
                                                                            value={
                                                                                countryISOCode ===
                                                                                    COUNTRY_CODE_JAPN &&
                                                                                    requestedDeliveryDateVisibility ===
                                                                                    VISIBLE &&
                                                                                    requestedDeliveryDateMandatory ===
                                                                                    'YES' &&
                                                                                    RequestDeliveryDate
                                                                                    ? shippingMethodValue
                                                                                    : countryISOCode ===
                                                                                        COUNTRY_CODE_JAPN &&
                                                                                        requestedDeliveryDateVisibility ===
                                                                                        VISIBLE &&
                                                                                        requestedDeliveryDateMandatory ===
                                                                                        'NO'
                                                                                        ? shippingMethodValue
                                                                                        : requestedDeliveryDateVisibility !==
                                                                                            VISIBLE ||
                                                                                            countryISOCode !==
                                                                                            COUNTRY_CODE_JAPN
                                                                                            ? shippingMethodValue
                                                                                            : ''
                                                                            }
                                                                            options={
                                                                                countryISOCode ===
                                                                                    COUNTRY_CODE_JAPN &&
                                                                                    !showShippingMethod &&
                                                                                    selectedAccount
                                                                                    ? requestedDeliveryDateVisibility ===
                                                                                        VISIBLE &&
                                                                                        (requestedDeliveryDateMandatory ===
                                                                                            'YES' ||
                                                                                            requestedDeliveryDateMandatory ===
                                                                                            'NO') &&
                                                                                        RequestDeliveryDate
                                                                                        ? shippingMethod
                                                                                        : requestedDeliveryDateVisibility !==
                                                                                            VISIBLE
                                                                                            ? shippingMethod
                                                                                            : !RequestDeliveryDate &&
                                                                                                requestedDeliveryDateVisibility ===
                                                                                                VISIBLE &&
                                                                                                requestedDeliveryDateMandatory ===
                                                                                                'YES'
                                                                                                ? ''
                                                                                                : shippingMethod
                                                                                    : requestedDeliveryDateMandatory ===
                                                                                        'YES' &&
                                                                                        countryISOCode !==
                                                                                        US_COUNTRY_CODE &&
                                                                                        showShippingMethod
                                                                                        ? ''
                                                                                        : shippingMethod
                                                                            }
                                                                            placeholder={t(
                                                                                'reportUsage.replen.selectShipToAddress.SelectShipToAddressOutside.selectShippingMethod'
                                                                            )}
                                                                            optionLabel="shippingMethodName"
                                                                            onChange={(value)=>{
                                                                                if (!value || value === '') {
                                                                                    setShippingMethodValue('');
                                                                                    initialShippingMethodRef.current = null;
                                                                                } else {
                                                                                    setShippingMethodValue(value);
                                                                                    initialShippingMethodRef.current = null;
                                                                                }
                                                                                setUsageTransferRecipient('');
                                                                                setTransferRecipientValue('');
                                                                                setTransferRecipientSelectedValue('');
                                                                            }
                                                                            }
                                                                            disabled={
                                                                                countryISOCode !==
                                                                                    COUNTRY_CODE_JAPN
                                                                                    ? selectedShipTo ===
                                                                                    ''
                                                                                    : false
                                                                            }
                                                                        />
                                                                    </ShippingContainerSize>
                                                                    {transferRecipientMeta.includes(shippingMethodValue?.shippingMethodId)
                                                                        && (
                                                                            <ShippingContainerSize
                                                                                flexBasis="46%"
                                                                                marginBottom={
                                                                                    //   window.innerWidth <=
                                                                                    //   sizes.smalDevice
                                                                                    //       ? '16px'
                                                                                    //   :
                                                                                    '16px'
                                                                                }
                                                                            >
                                                                                <Title
                                                                                    display={
                                                                                        'flex'
                                                                                    }
                                                                                >
                                                                                    {t(
                                                                                        'reportUsage.replen.selectShipToAddress.transferRecipient'
                                                                                    )}
                                                                                    <Title
                                                                                        marginBottom={
                                                                                            true
                                                                                        }
                                                                                        color={
                                                                                            '#ED002A'
                                                                                        }
                                                                                        showAstrisk={transferRecipientMandatory === MANDATORY}
                                                                                    >{`\u00A0${t(
                                                                                        'common.transferRecipientImportantMsg'
                                                                                    )}`}</Title>
                                                                                </Title>
                                                                                <AutoComplete
                                                                                    inputRef={
                                                                                        transferRecipientRef
                                                                                    }
                                                                                    showScrollBar={
                                                                                        true
                                                                                    }
                                                                                    disableClearable={
                                                                                        false
                                                                                    }
                                                                                    isFullWidth={
                                                                                        true
                                                                                    }
                                                                                    boxShadow={
                                                                                        '0px 3px 6px #00000029'
                                                                                    }
                                                                                    options={
                                                                                        transferRecipient &&
                                                                                            transferRecipient?.length >
                                                                                            0
                                                                                            ? transferRecipient
                                                                                            : []
                                                                                    }
                                                                                    value={
                                                                                        transferRecipientSelectedValue ??
                                                                                        ''
                                                                                    }
                                                                                    inputValue={
                                                                                        selectedAccount !== ''
                                                                                            ? transferRecipientValue?.accountName
                                                                                                ? transferRecipientValue?.accountName
                                                                                                : transferRecipientSelectedValue || ''
                                                                                            : ''

                                                                                    }
                                                                                    clearOnBlur={
                                                                                        false
                                                                                    }
                                                                                    itemTemplate={(
                                                                                        option
                                                                                    ) =>
                                                                                        OptionTransferRecipient(
                                                                                            option
                                                                                        )
                                                                                    }
                                                                                    onChange={(
                                                                                        value,
                                                                                        reason
                                                                                    ) => {
                                                                                        if (
                                                                                            reason ===
                                                                                            'clear'
                                                                                        ) {
                                                                                            handleTransferRecipient(
                                                                                                'handleInputChange',
                                                                                                '',
                                                                                                '',
                                                                                                true
                                                                                            );
                                                                                        }
                                                                                        handleTransferRecipient(
                                                                                            'handleInputChange',
                                                                                            '',
                                                                                            value
                                                                                                ? value
                                                                                                : '',
                                                                                            reason
                                                                                        );
                                                                                        if (
                                                                                            value ===
                                                                                            ''
                                                                                        )
                                                                                            setOpenTransferRecipientDropdown(
                                                                                                true
                                                                                            );
                                                                                    }}
                                                                                    hideNoOptionText={
                                                                                        false
                                                                                    }
                                                                                    placeholder={t(
                                                                                        'reportUsage.replen.selectShipToAddress.transferRecipientPlaceholder'
                                                                                    )}
                                                                                    field="accountName"
                                                                                    optionValue="accountName"
                                                                                    id={
                                                                                        'reportUsage-replen-selectShipTo-transferRecipient'
                                                                                    }
                                                                                    onInputChange={(
                                                                                        event,
                                                                                        value,
                                                                                        reset
                                                                                    ) => {
                                                                                        if (
                                                                                            value
                                                                                        ) {
                                                                                            value?.length !==
                                                                                                11
                                                                                                ? handleTransferRecipient(
                                                                                                    'handleSearch',
                                                                                                    event,
                                                                                                    value
                                                                                                        ? value
                                                                                                        : '',
                                                                                                    reset
                                                                                                )
                                                                                                  : () => {};
                                                                                        } else if (
                                                                                            reset ===
                                                                                            'clear'
                                                                                        ) {
                                                                                            handleTransferRecipient(
                                                                                                'handleSearch',
                                                                                                '',
                                                                                                '',
                                                                                                reset
                                                                                            );
                                                                                        }
                                                                                    }}
                                                                                    loading={
                                                                                        transferRecipientLoading
                                                                                    }
                                                                                    noOptionsText={
                                                                                        !transferRecipientLoading &&
                                                                                            transferRecipient?.length ===
                                                                                            0
                                                                                            ? t(
                                                                                                'calendar.filterResultsPanel.noOptionText'
                                                                                            )
                                                                                            : transferRecipientLoading &&
                                                                                            t(
                                                                                                'common.loadingText'
                                                                                            )
                                                                                    }
                                                                                    onFocus={(
                                                                                        event
                                                                                    ) =>
                                                                                        handleTransferRecipient(
                                                                                            'handleOnFocus',
                                                                                            event
                                                                                        )
                                                                                    }
                                                                                    disabled={
                                                                                        selectedAccount ===
                                                                                        ''
                                                                                    }
                                                                                    onOpen={() => {
                                                                                        try {
                                                                                            if (
                                                                                                selectedAccount ===
                                                                                                ''
                                                                                            ) {
                                                                                                setOpenTransferRecipientDropdown(
                                                                                                    false
                                                                                                );
                                                                                            } else {
                                                                                                setOpenTransferRecipientDropdown(
                                                                                                    true
                                                                                                );
                                                                                            }
                                                                                        } catch (error) {
                                                                                            logErrorToConsole(error);
                                                                                        }
                                                                                    }}
                                                                                    onClose={() => {
                                                                                        try {
                                                                                            setOpenTransferRecipientDropdown(
                                                                                                false
                                                                                            );
                                                                                        } catch (error) {
                                                                                            logErrorToConsole(error);
                                                                                        }
                                                                                    }}
                                                                                    open={
                                                                                        transferRecipientValue?.accountName
                                                                                            ? false
                                                                                            : openTransferRecipientDropdown
                                                                                    }
                                                                                    readOnly={
                                                                                        transferRecipientValue?.accountName
                                                                                    }
                                                                                    detailsMargin
                                                                                    marginLeft={
                                                                                        '1.5px'
                                                                                    }
                                                                                    zIndex={
                                                                                        '99999'
                                                                                    }
                                                                                />
                                                                            </ShippingContainerSize>
                                                                        )}
                                                                </ShippingContainer>
                                                            </MainContainer>
                                                        </>
                                                    )}
                                                </>
                                            )}
                                        </CollapsableCard>
                                        <CommonEmptyBox mobileMargin={'40%'} />
                                    </>
                                )}
                            </>
                        )}
                    </SelectShipToAddressContainer>
                    {!advanceSearchValue && territory === WithinTerritory() ? (
                        <>
                            <BottomNavigation
                                justifyContent={'flex-end'}
                                opacity={'1'}
                                position={'absolute'}
                                mbPosition={'fixed'}
                                isIPadPotrait={true}
                                iPadPortraitFooterPosition={'absolute'}
                                padding={'5px'}
                                right={'0'}
                            >
                                <AdvanceSelectButton>
                                    <Button
                                        id={'reportUsage-replen-shipToAddressApplyButton'}
                                        show={true}
                                        // primary={enableAddressButton}
                                        variant={enableAddressButton ? ButtonStyles?.primary : ButtonStyles?.disabled}
                                        disabled={!enableAddressButton}
                                        height={'38px'}
                                        clicked={() => {
                                            try {
                                                // ApplyShipToAddress();
                                                setShipToClick(true);
                                                setApplyClickOutside(false);
                                                applyShippingAddress();
                                                onClose(true);
                                            } catch (error) {
                                                logErrorToConsole(error);
                                            }
                                        }}
                                        margin={'5px'}
                                        // fontSize={'15px'}
                                        width={
                                            screenWidth <= 576
                                                ? '332px'
                                                : '244px'
                                        }
                                    >
                                        {t(
                                            'reportUsage.replen.selectShipToAddress.SelectShipToAddressOutside.applyShipToAddress'
                                        )}
                                    </Button>
                                </AdvanceSelectButton>
                            </BottomNavigation>
                        </>
                    ) : null}
                </>
            </ModalDialog>
        </>
    );
};

export default ShipAddressModal;
